<template>
   <div class="project_detail_wrap" ref="project_detail_wrap" v-loading="detailLoading">
        <div class="project_detail_info" ref="project_detail_info">
            <div class="project_detail_title flex_js_wrap">
                <div class="title_wrap">
                    <h5 class="ellipsis" v-text="projectDetail.project_manage_name"></h5>
                    <div class="status_wrap">
                        <span class="status_text status0"  v-if="projectDetail.status == 0 ">进行中</span>
                        <span class="status_text status1"  v-if="projectDetail.status == 1 ">已完结</span>
                        <span class="status_text status2"  v-if="projectDetail.status == 2 ">已关闭</span>
                    </div>
                </div>
                <div class="handle_wrap">
                    <el-dropdown v-if="projectDetail.status == 0" placement="bottom-end" trigger="click">
                        <span class="handle_wrap_item"> <i class="iconfont icon-a-tianjiamiaobian"></i>快捷操作</span>
                        <el-dropdown-menu slot="dropdown">

                            <el-dropdown placement="bottom-end"  style="display: block !important;" v-if="userPermission.includes('all') || userPermission.includes('business_manage')">
                                <el-dropdown-item >新增商机</el-dropdown-item>
                                <el-dropdown-menu slot="dropdown" class="custom_dropdown_translate">
                                    <el-dropdown-item @click.native="handleClickRelateHandle('add_business')">新建商机</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickRelateHandle('relate_business')">关联商机</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>

                            <el-dropdown placement="bottom-end" style="display: block !important;" v-if="userPermission.includes('all') || userPermission.includes('business_manage')">
                                <el-dropdown-item >新增订单</el-dropdown-item>
                                <el-dropdown-menu slot="dropdown" class="custom_dropdown_translate">
                                    <el-dropdown-item @click.native="handleClickRelateHandle('add_order')">新建订单</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickRelateHandle('relate_order')">关联订单</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>

                            <el-dropdown placement="bottom-end"   style="display: block !important;" v-if="userPermission.includes('all') || userPermission.includes('business_manage')">
                                <el-dropdown-item >新增工单</el-dropdown-item>
                                <el-dropdown-menu slot="dropdown" class="custom_dropdown_translate">
                                    <el-dropdown-item @click.native="handleClickRelateHandle('add_work_order')">新建工单</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickRelateHandle('relate_work_order')">关联工单</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>


                            <el-dropdown-item  v-if="userPermission.includes('all') || userPermission.includes('financial_payment')" @click.native="handleClickRelateHandle('payment')">新建回款</el-dropdown-item>
                            <el-dropdown-item @click.native="handleClickAddCost" v-if="userPermission.includes('all') || userPermission.includes('financial_cost')">新建成本</el-dropdown-item>
                            <el-dropdown-item  v-if="userPermission.includes('all') || userPermission.includes('financial_payment')" @click.native="handleClickRelateHandle('invoice')">新建开票</el-dropdown-item>


                            <el-dropdown placement="bottom-end"  style="display: block !important;">
                                <el-dropdown-item >新建出入库</el-dropdown-item>
                                <el-dropdown-menu slot="dropdown" class="custom_dropdown_translate">
                                    <el-dropdown-item @click.native="handleClickRelateHandle('add_out_record')">新建出库</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickRelateHandle('add_in_record')">新建入库</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>


                            <el-dropdown placement="bottom-end"  style="display: block !important;">
                                <el-dropdown-item >新增审批</el-dropdown-item>
                                <el-dropdown-menu slot="dropdown" class="custom_dropdown_translate">
                                    <el-dropdown-item @click.native="handleClickRelateHandle('add_approval')">发起审批</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickRelateHandle('relate_approval')">关联审批</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>

                            <el-dropdown-item @click.native="handleClickRelateHandle('add_member')"  v-if="userPermission.includes('all') || userPermission.includes('member_operate')">添加成员</el-dropdown-item>
<!--                            <el-dropdown-item class="project_upload_button">上传文件-->
<!--                                <input  class="upload_input" type="file" @change="handleUploadChange($event)">-->
<!--                            </el-dropdown-item>-->
                        </el-dropdown-menu>
                    </el-dropdown>


                    <el-dropdown placement="bottom-end" trigger="click" v-if="userPermission.includes('all')">
                        <span class="handle_wrap_item"> <i class="iconfont icon-gengduo"></i>更多</span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item  @click.native="handleClickEditProject()">编辑</el-dropdown-item>
                            <el-dropdown-item  @click.native="handleClickChangePerson()">更换负责人</el-dropdown-item>
                            <el-dropdown-item v-if="projectDetail.status == 0" @click.native="handleClickEnd()">完结</el-dropdown-item>
                            <el-dropdown-item v-if="projectDetail.status == 1" @click.native="handleClickCancelEnd()">取消完结</el-dropdown-item>
                            <el-dropdown-item v-if="projectDetail.status == 0" @click.native="handleClickClose()">关闭</el-dropdown-item>
                            <el-dropdown-item v-if="projectDetail.status == 2" @click.native="handleClickCancelClose()">取消关闭</el-dropdown-item>
                            <el-dropdown-item v-if="projectDetail.status == 2" @click.native="handleClickDelete()">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="project_detail_base">
                <div class="project_detail_base_top flex_js_wrap">
                    <div class="flex_js_wrap">
                        <userDetailPopover v-if="projectDetail.head_user" :uid="projectDetail.head_user.id">
                            <div slot="container">
                                <div class="user_head">
                                    <img :src="projectDetail.head_user.avatar ? projectDetail.head_user.avatar : defaultImg" alt="" />
                                    <span v-text="projectDetail.head_user.name"></span>
                                </div>
                            </div>
                        </userDetailPopover>
                        <span class="line"></span>
                        <span class="time" v-if="projectDetail.updated_at" v-text="projectDetail.updated_at.substring(0, 10)"></span>
                        <span class="time" v-if="projectDetail.status > 0 &&  projectDetail.end_date" v-text="'— '+ projectDetail.end_date.substring(0, 10)"></span>

                    </div>
                    <div >
                        <el-link :underline="false" type="primary" @click="handleClickElaborateOrRetract">
                            {{ elaborateOrRetract ? '收起详情' : '展开详情' }} <i
                                :class="elaborateOrRetract?'icon-shangjiantou':'icon-xiajiantou'"
                                class="iconfont"></i>
                        </el-link>
                    </div>
                </div>
                <div v-if="elaborateOrRetract" class="project_detail_base_bottom">
                    <el-form size="small" ref="detailForm" label-position="top" class="custom_detail_form">
                        <el-form-item label="项目地址" prop="addr">
                            <div class="field_name" v-text="projectDetail.country_region + ' ' + projectDetail.addr"></div>
                        </el-form-item>
                        <el-form-item label="项目概况" prop="note">
                            <div class="field_name" v-text="projectDetail.note"></div>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>

        <div class="project_detail_tab_list" :style="{height:max_height +'px'}">

            <el-tabs v-model="activeName" @tab-click="handleClickTab">
                <el-tab-pane label="项目看板" name="project_board">
                    <div class="project_board_wrap">

                        <div :class="progressElaborateOrRetract ? 'height_auto' :''" ref="project_board_progress" class="project_board_progress">
                            <div class="project_board_progress_top">
                                <div class="title_wrap">
                                    <h5>项目进度</h5>
                                    <span>根据日期自动匹配项目进度</span>
                                </div>
                                <div class="handle_wrap">
                                    <ul class="project_list_type_list">
                                        <el-tooltip content="切换为时间轴" effect="dark" placement="top">
                                            <li :class="{'active':listMode==='time_axis'}" class="project_list_type_item"  @click="handleClickProjectListType('time_axis')">
                                                <i class="iconfont icon-shijianzhou"></i>
                                                <span>时间轴</span>
                                            </li>
                                        </el-tooltip>
                                        <el-tooltip content="切换为甘特图" effect="dark" placement="top">
                                            <li :class="{'active':listMode==='gantt_chart'}" class="project_list_type_item"  @click="handleClickProjectListType('gantt_chart')">
                                                <i class="iconfont icon-gantetu"></i>
                                                <span>甘特图</span>
                                            </li>
                                        </el-tooltip>
                                    </ul>
                                    <el-button v-if="projectDetail.status == 0" size="small" type="primary" @click="handleClickAddProjectRecord">新增记录</el-button>
                                </div>
                            </div>
                            <div class="project_board_progress_bottom">
                                <template v-if="listMode==='time_axis'">
                                    <div class="project_board_progress_time_axis" ref="project_board_progress_time_axis">
                                        <div v-if="logList.length > 5" class="handle_radio handle_prev" @click="handleClickTimeAxisPrev"><i class="el-icon-arrow-left"></i></div>
                                        <div v-if="logList.length > 5" class="handle_radio handle_next" @click="handleClickTimeAxisNext"><i class="el-icon-arrow-right"></i></div>
                                        <ul ref="project_board_progress_time_axis_ul">
                                            <li>
                                                <div class="top">
                                                    <div class="time">开始</div>
                                                    <span></span>
                                                </div>
                                            </li>
                                            <li v-for="(item,key) in logList" :key="key">
                                                <div class="top">
                                                    <div class="time" v-text="item.date"></div>
                                                    <span></span>
                                                </div>
                                                <div class="bottom">
                                                    <div class="record_item" v-for="log in item.logs">
                                                        <div v-if="log.type == 'custom'">
                                                            <div v-html="log.user.name + '：' + log.content.text + updatedDate(item.date,log.updated_at)"></div>
                                                            <div class="handle_wrap">
                                                                <span class="handle_icon_wrap" @click="handleClickEditProjectRecord(log.log_id)">
                                                                    <i class="iconfont icon-bianji"></i>
                                                                </span>
                                                                <span class="handle_icon_wrap handle_icon_danger_wrap"  @click="handleClickDelProjectRecord(log.log_id)">
                                                                    <i class="iconfont icon-shanchu1"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <span v-text="getLogDescriptions(log).title"></span>
                                                            <span @click="handleClickRelateHandle(getLogDescriptions(log).handle_type,getLogDescriptions(log).info)" class="link-label" v-text="getLogDescriptions(log).relate_num"></span>
                                                            <span v-text="getLogDescriptions(log).content_text"></span>
                                                            <span class="link-label" v-if="getLogDescriptions(log).derivative_num" v-text="getLogDescriptions(log).derivative_num" @click="handleClickRelateHandle(getLogDescriptions(log).derivative_handle_type,getLogDescriptions(log).derivative)"></span>
                                                        </div>


                                                    </div>
                                                </div>
                                            </li>
                                            <li :class="{close_li_class : projectDetail.status > 0}">
                                                <div class="top">
                                                    <div class="time" v-if="projectDetail.status == 1">完结</div>
                                                    <div class="time" v-else-if="projectDetail.status == 2">关闭</div>
                                                    <div class="time" v-else></div>
                                                    <span></span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </template>

                                <template v-if="listMode==='gantt_chart'"></template>
                            </div>
                            <div class="project_board_progress_more" v-if="isLogMore">
                                <el-link :underline="false" type="primary" @click="handleClickProgressElaborateOrRetract">
                                    {{ progressElaborateOrRetract ? '收起' : '展开' }} <i
                                        :class="progressElaborateOrRetract?'icon-shangjiantou':'icon-xiajiantou'"
                                        class="iconfont"></i>
                                </el-link>
                            </div>
                        </div>

                        <div class="project_board_finance">
                            <div class="project_board_finance_title">财务看板</div>
                            <div class="project_board_finance_bottom">
                                <div class="project_board_finance_income">
                                    <div class="project_board_finance_income_title">
                                        项目收入
                                    </div>
                                    <div class="project_board_finance_income_content">
                                        <div class="project_board_finance_income_left">
                                            <div class="project_board_finance_income_left_item">
                                                项目订单总金额：{{financialBoardData.board.totalPrice}}
                                            </div>
                                            <div class="project_board_finance_income_left_item">
                                                实际回款总金额：{{financialBoardData.board.repayPrice}}
                                            </div>
                                            <div class="project_board_finance_income_left_item">
                                                待回款总金额：{{financialBoardData.board.noRepayPrice }}
                                            </div>
                                            <div class="project_board_finance_income_left_item">
                                                采购退款金额：{{financialBoardData.board.purchaseRefundPrice}}
                                            </div>
                                            <div class="project_board_finance_income_left_item project_board_finance_income_left_item_blod" v-if="userPermission.includes('all') || userPermission.includes('financial_profit')">
                                                项目实际利润
                                                <el-tooltip class="item" content="项目实际利润＝实际回款总金额 - 项目成本总金额" effect="dark" placement="bottom">
                                                    <span class="handle_icon_wrap"><i class="iconfont icon-yiwen"></i></span>
                                                </el-tooltip>
                                               ：{{financialBoardData.board.profit}}
                                            </div>

                                        </div>
                                        <div class="project_board_finance_income_right">
                                            <el-progress type="circle" :percentage="financialBoardData.repayPricePercentage" :stroke-width="10" :width="160" :show-text="false"></el-progress>
                                            <div class="project_board_finance_income_right_text">
                                                <h5>{{financialBoardData.repayPricePercentage}}%</h5>
                                                <p>已回款</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="project_board_finance_cost" v-if="userPermission.includes('all') || userPermission.includes('financial_profit')">
                                    <div class="project_board_finance_cost_top">
                                        <div class="project_board_finance_cost_title">
                                            项目成本
                                        </div>
                                        <div class="project_board_finance_cost_handle">
                                            <ul class="project_list_type_list">
                                                <li :class="{'active':costMode==='pie'}" class="project_list_type_item"  @click="handleClickCostCharts('pie')">
                                                    <i class="iconfont icon-bingtu"></i>
                                                </li>
                                                <li :class="{'active':costMode==='bar'}" class="project_list_type_item"  @click="handleClickCostCharts('bar')">
                                                    <i class="iconfont icon-zhuzhuangtu"></i>
                                                </li>
                                            </ul>
                                            <el-button v-if="projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('financial_cost'))" size="small" type="primary" @click="handleClickAddCost">新建成本</el-button>
                                        </div>
                                    </div>
                                    <div class="project_board_finance_cost_bottom">
                                        <img v-if="financialBoardData.cost.filter(item=>item.cost >0).length == 0" src="https://download.hecoos.com/enlightv/2025-09/c59611d310cc1817cc597f645c1221a2.png" alt="">
                                        <template v-else>
                                            <template v-if="costMode === 'pie'">
                                                <div class="echarts_container" id="container1"></div>
                                                <div class="cost_text_blod">项目总成本：{{financialBoardData.totalCost}}</div>
                                            </template>
                                            <template v-if="costMode === 'bar'">
                                                <div class="echarts_container" id="container2"></div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>
                </el-tab-pane>
                <el-tab-pane label="业务相关" name="business_related" v-if="userPermission.includes('all') || userPermission.includes('business_related_detail')">
                    <div class="project_business_related_wrap">
                        <div class="project_related_tab">
                            <span @click="handleClickRelatedTab('business')" :class="{'active' : relatedTabActive == 'business'}">商机 <i v-text="projectDetail.business_number"></i></span>
                            <span @click="handleClickRelatedTab('order')" :class="{'active' : relatedTabActive == 'order'}">订单 <i v-text="projectDetail.order_number"></i></span>
                            <span @click="handleClickRelatedTab('work_order')" :class="{'active' : relatedTabActive == 'work_order'}">工单 <i v-text="projectDetail.work_order_number"></i></span>
                        </div>
                        <div class="project_related_search flex_js_wrap">
                            <el-input v-if="relatedTabActive == 'business'" size="small" v-model="business_related_keyword" placeholder="请输入搜索内容"  clearable ref="search_input_ref"  @clear="handleClickBusinessRelatedSearch"  @keyup.enter.native="handleKeyUpEnter" @blur="handleClickBusinessRelatedSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickBusinessRelatedSearch"></i>
                            </el-input>
                            <el-input v-if="relatedTabActive == 'order'" size="small" v-model="business_related_keyword" placeholder="请输入搜索内容"  clearable ref="search_input_ref" @clear="handleClickBusinessRelatedSearch"  @keyup.enter.native="handleKeyUpEnter" @blur="handleClickBusinessRelatedSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickBusinessRelatedSearch"></i>
                            </el-input>
                            <el-input v-if="relatedTabActive == 'work_order'" size="small" v-model="business_related_keyword" placeholder="请输入搜索内容"  clearable ref="search_input_ref" @clear="handleClickBusinessRelatedSearch"  @keyup.enter.native="handleKeyUpEnter" @blur="handleClickBusinessRelatedSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickBusinessRelatedSearch"></i>
                            </el-input>
                            <template v-if="projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('business_manage'))">
                                <el-dropdown placement="bottom-end" trigger="click" v-if="relatedTabActive == 'business'">
                                    <el-button size="small" type="primary">新增商机</el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="handleClickRelateHandle('add_business')">新建商机</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleClickRelateHandle('relate_business')">关联商机</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <el-dropdown placement="bottom-end" trigger="click" v-if="relatedTabActive == 'order'">
                                    <el-button size="small" type="primary">新增订单</el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="handleClickRelateHandle('add_order')">新建订单</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleClickRelateHandle('relate_order')">关联订单</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <el-dropdown placement="bottom-end" trigger="click" v-if="relatedTabActive == 'work_order'">
                                    <el-button size="small" type="primary">新增工单</el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="handleClickRelateHandle('add_work_order')">新建工单</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleClickRelateHandle('relate_work_order')">关联工单</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </div>

                        <div class="project_business_related_table">
                            <div v-show="relatedTabActive==='business'">
                                <CustomVxeTable
                                        id="relatedBusiness"
                                        ref="customTable"
                                        class="custom-table"
                                        :empty-render="{ name: 'NotData' }"
                                        :isShowToolBar="true"
                                        :pagination.sync="pagination"
                                        :reduceHeight="reduceHeight"
                                        :tableData="businessTableList"
                                        @handleCurrentChange="handleCurrentChange"
                                        @handleSizeChange="handleSizeChange"
                                >
                                    <vxe-column v-for="field in formInfoList"
                                                :key="field.field_key"
                                                :align="field.align?'right':'left'"
                                                :field="field.field_key"
                                                :title="field.field_name"
                                                :fixed="field.field_key==='name'?'left':''"
                                                show-overflow
                                                width="150">
                                        <template #default="{ row }">
                                            <div v-if="field.field_key==='name'"
                                                 class="link-label"
                                                 @click.stop="handleClickRelateHandle('business_detail',row)">
                                                <span v-text="row.name"></span>
                                            </div>
                                            <div v-else>
                                                <div v-if="field.field_type==='contact'">
                                                    <div v-if="row[field.field_key].length">
                                                        <div v-for="item in row[field.field_key]"
                                                             class="custom_contact_field_wrap">
                                                            <PersonnelCard :userId="item.id" v-if="item.id">
                                                                <template slot="container">
                                                                    <img :src="item.avatar?item.avatar:defaultImg" alt=""
                                                                         class="avatar">
                                                                    <span class="name" v-text="item.name"></span>
                                                                </template>
                                                            </PersonnelCard>
                                                        </div>
                                                    </div>
                                                    <span v-else>--</span>
                                                </div>
                                                <div v-else-if="field.field_type==='department'">
                                                    <div v-if="row[field.field_key].length">
                                                        <div v-for="item in row[field.field_key]">
                                                            <el-tooltip :content="item.full_path" effect="dark" placement="top">
                                                                <span v-text="item.department_name"></span>
                                                            </el-tooltip>
                                                        </div>
                                                    </div>
                                                    <span v-else>--</span>
                                                </div>
                                                <div v-else-if="field.field_type==='radio'">
                                    <span v-if="row[field.field_key]"
                                          :class="{'is_tag_interaction':field.extend.tag_interaction}"
                                          v-text="row[field.field_key]"></span>
                                                    <span v-else>--</span>
                                                </div>
                                                <div v-else-if="field.field_type==='checkbox'">
                                                    <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span v-for="item in row[field.field_key]"
                                              :class="{'is_tag_interaction':field.extend.tag_interaction}"
                                              v-text="item">
                                        </span>
                                                    </div>
                                                    <span v-else>--</span>
                                                </div>
                                                <div v-else-if="field.field_type==='checkbox_user_tag'">
                                                    <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span v-for="item in row[field.field_key]"
                                              class="is_tag_interaction"
                                              v-text="item.name">
                                        </span>
                                                    </div>
                                                    <span v-else>--</span>
                                                </div>
                                                <div v-else-if="field.field_type==='image'">
                                                    <div v-if="row[field.field_key].length" class="table_custom_image_wrap">
                                                        <el-image
                                                                :preview-src-list="row[field.field_key].map(img=>img.file_path)"
                                                                :src="row[field.field_key][0].file_path"
                                                                fit="cover">
                                                        </el-image>
                                                        <el-popover :visible-arrow="false"
                                                                    placement="bottom-start"
                                                                    popper-class="table_custom_image_popover"
                                                                    title=""
                                                                    trigger="hover"
                                                                    width="254">
                                                            <div slot="reference">
                                                <span v-if="row[field.field_key].length>1"
                                                      class="image_count"
                                                      v-text="`+${row[field.field_key].length-1}`"></span>
                                                            </div>
                                                            <ul class="image_list">
                                                                <li v-for="(img,img_index) in row[field.field_key]"
                                                                    :key="img_index"
                                                                    class="image_item">
                                                                    <el-image
                                                                            :preview-src-list="row[field.field_key].map(img=>img.file_path)"
                                                                            :src="img.file_path"
                                                                            fit="cover">
                                                                    </el-image>
                                                                </li>
                                                            </ul>
                                                        </el-popover>
                                                    </div>
                                                    <span v-else>--</span>
                                                </div>
                                                <div v-else-if="field.field_type==='file'">
                                                    <div v-if="row[field.field_key].length"></div>
                                                    <span v-else>--</span>
                                                </div>
                                                <div v-else-if="field.field_type==='invoice'">
                                                    <div v-if="row[field.field_key].length"></div>
                                                    <span v-else>--</span>
                                                </div>
                                                <div v-else-if="field.field_type==='relate_approve_form'"></div>
                                                <div v-else-if="field.field_type==='id_card'">
                                                    <div v-if="row[field.field_key].value" class="custom_id_card_field_wrap">
                                                        <span v-text="row[field.field_key].value"></span>
                                                        <el-popover placement="bottom"
                                                                    popper-class="id_card_detail_popper"
                                                                    trigger="click"
                                                                    width="350">
                                            <span slot="reference" class="handle_icon_wrap">
                                                 <i class="iconfont icon-shenfenzheng"></i>
                                            </span>
                                                            <el-form size="small">
                                                                <el-form-item v-if="row[field.field_key].name" label="姓名"
                                                                              prop="name">
                                                                    <span v-text="row[field.field_key].name"></span>
                                                                </el-form-item>
                                                                <el-form-item v-if="row[field.field_key].birthday" label="出生日期"
                                                                              prop="birthday">
                                                                    <span v-text="row[field.field_key].birthday"></span>
                                                                </el-form-item>
                                                                <el-form-item v-if="row[field.field_key].address" label="家庭住址"
                                                                              prop="name">
                                                                    <span v-text="row[field.field_key].address"></span>
                                                                </el-form-item>
                                                                <el-form-item label="身份证号" prop="value">
                                                                    <span v-text="row[field.field_key].value"></span>
                                                                </el-form-item>
                                                            </el-form>
                                                            <img alt=""
                                                                 class="ic_card_icon"
                                                                 src="https://download.hecoos.com/enlightv/2024-48/2d35b952fcb868047612cca8bf82a615.png">
                                                        </el-popover>
                                                    </div>
                                                    <span v-else>--</span>
                                                </div>
                                                <div v-else-if="field.field_type==='paying_teller'">
                                                    <div v-if="row[field.field_key]&&row[field.field_key].text"
                                                         class="custom_paying_teller_field_wrap">
                                                        <span v-text="row[field.field_key].text"></span>
                                                        <el-popover placement="bottom"
                                                                    popper-class="paying_teller_detail_popper"
                                                                    trigger="click"
                                                                    width="350">
                                            <span slot="reference" class="handle_icon_wrap">
                                                 <i class="iconfont icon-zhanghu"></i>
                                            </span>
                                                            <el-form class="custom_detail_form" label-position="top"
                                                                     size="small">
                                                                <el-form-item label="账户类型" prop="account_type">
                                                                    <span v-text="row[field.field_key].account_type===1?'个人账户':'对公账户'"></span>
                                                                </el-form-item>
                                                                <el-form-item label="户名" prop="account_name">
                                                                    <span v-text="row[field.field_key].account_name"></span>
                                                                </el-form-item>
                                                                <el-form-item label="账号" prop="card_number">
                                                                    <span v-text="row[field.field_key].card_number"></span>
                                                                </el-form-item>
                                                                <el-form-item label="所属银行" prop="bank_name">
                                                                    <span v-text="row[field.field_key].bank_name"></span>
                                                                </el-form-item>
                                                                <el-form-item v-if="field.extend.bank_branch_is_show"
                                                                              label="银行支行"
                                                                              prop="bank_branch">
                                                                    <span v-text="row[field.field_key].bank_branch"></span>
                                                                </el-form-item>
                                                            </el-form>
                                                        </el-popover>
                                                    </div>
                                                    <span v-else>--</span>
                                                </div>
                                                <div v-else-if="field.field_type==='table'">
                                                </div>
                                                <div v-else-if="field.field_type==='radio_customer'">
                                            <span class="link-label"
                                                  @click="handleClickRelateHandle('company_detail',row)"
                                                  v-text="row.customer_id.text"></span>
                                                </div>
                                                <div v-else-if="field.field_type==='customer_contact'">
                                                    <span v-for="item in row.contact_id" v-text="item.name"></span>
                                                </div>
                                                <div v-else-if="field.field_type==='radio_project_stage'">
                                                    <span v-text="row[field.field_key].text"></span>
                                                </div>
                                                <div v-else-if="field.field_type==='system'">
                                            <span v-if="field.field_key==='relate_quotation'"
                                                  class="link-label"
                                                  @click="handleClickRelateHandle('view_the_quotation',row)">查看报价单</span>
                                                    <span v-if="field.field_key==='project_stage_start_at'"
                                                          v-text="row[field.field_key]"></span>
                                                </div>
                                                <span v-else
                                                      v-text="row[field.field_key]?row[field.field_key]:'--'"></span>
                                            </div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="operate" fixed="right" width="70">
                                        <template #header>
                                            <span>操作</span>
                                        </template>
                                        <template #default="{ row }">
                                            <div class="table-operate-icon">
<!--                                                <el-tooltip content="编辑" effect="dark" placement="top">-->
<!--                                                    <i class="iconfont icon-bianji" @click="handleClickRelateHandle('edit_business',row)"></i>-->
<!--                                                </el-tooltip>-->
                                                <el-dropdown placement="bottom-end" trigger="click">
                                                    <el-tooltip content="更多" effect="dark" placement="top">
                                                        <i class="iconfont el-icon-more"></i>
                                                    </el-tooltip>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <el-dropdown-item v-if="projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('business_manage'))" @click.native=" handleClickRelateHandle('business_disassociation',row)">取消关联</el-dropdown-item>
<!--                                                        <el-dropdown-item @click.native=" handleClickRelateHandle('advance_next_stage',row)" v-if="row.project_stage.value>0">推进阶段</el-dropdown-item>-->
<!--                                                        <el-dropdown-item @click.native=" handleClickRelateHandle('business_change_person',row)">更换负责人</el-dropdown-item>-->
                                                        <el-dropdown-item @click.native=" handleClickRelateHandle('add_New_quotation',row)">新增报价</el-dropdown-item>
<!--                                                        <el-dropdown-item @click.native=" handleClickRelateHandle('add_member_business',row)">添加成员</el-dropdown-item>-->
<!--                                                        <el-dropdown-item @click.native=" handleClickRelateHandle('del_business',row) ">删除</el-dropdown-item>-->
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                            </div>
                                        </template>
                                    </vxe-column>
                                </CustomVxeTable>
                            </div>
                            <div v-show="relatedTabActive==='order'">
                                <CustomVxeTable
                                        id="relatedOrder"
                                        ref="customTable"
                                        class="custom-table"
                                        :empty-render="{ name: 'NotData' }"
                                        :isShowToolBar="true"
                                        :pagination.sync="pagination"
                                        :reduceHeight="reduceHeight"
                                        :tableData="orderTableList"
                                        @handleCurrentChange="handleCurrentChange"
                                        @handleSizeChange="handleSizeChange">
                                    <vxe-column fixed="left" title="订单编号" width="220">
                                        <template #default="{ row }">
                                            <div v-if="row.is_release===0" class="order_is_release">订单未发布</div>
                                            <div v-else class="order_num_wrap">
                                                <el-tooltip v-if="row.order_status===0"
                                                            effect="dark"
                                                            content="审批中"
                                                            placement="top">
                                            <span class="handle_icon_wrap">
                                                <i class="iconfont icon-shenpi_weixuanzhong1"></i>
                                            </span>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="row.order_status===2"
                                                            effect="dark"
                                                            content="已拒绝"
                                                            placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap">
                                                <i class="iconfont icon-tingyong"></i>
                                            </span>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="row.order_status===3"
                                                            effect="dark"
                                                            content="已撤销"
                                                            placement="top">
                                            <span class="handle_icon_wrap">
                                                <i class="iconfont icon-chehui"></i>
                                            </span>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="row.order_status===5"
                                                            effect="dark"
                                                            content="已关闭"
                                                            placement="top">
                                            <span class="handle_icon_wrap">
                                                <i class="el-icon-circle-close"></i>
                                            </span>
                                                </el-tooltip>
                                                <span class="link-label"
                                                      @click="handleClickRelateHandle('order_detail',row)"
                                                      v-text="row.order_num"></span>
                                                <el-tooltip content="复制"
                                                            effect="dark"
                                                            placement="top">
                                            <span class="handle_icon_wrap copy_icon"
                                                  @click="handleClickRelateHandle('copy',{text:row.order_num})">
                                                <i class="iconfont icon-fuzhi"></i>
                                            </span>
                                                </el-tooltip>
                                            </div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column v-for="field in formInfoList"
                                                :key="field.field_key"
                                                :align="field.align?'right':'left'"
                                                :field="field.field_key"
                                                :title="field.field_name"
                                                show-overflow
                                                width="150">
                                        <template #default="{ row }">
                                            <div v-if="field.field_type==='contact'">
                                                <div v-if="row[field.field_key].length">
                                                    <div v-for="item in row[field.field_key]"
                                                         class="custom_contact_field_wrap">
                                                        <PersonnelCard v-if="item.id" :userId="item.id">
                                                            <template slot="container">
                                                                <img :src="item.avatar?item.avatar:defaultImg" alt=""
                                                                     class="avatar">
                                                                <span class="name" v-text="item.name"></span>
                                                            </template>
                                                        </PersonnelCard>
                                                    </div>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type==='department'">
                                                <div v-if="row[field.field_key].length">
                                                    <div v-for="item in row[field.field_key]">
                                                        <el-tooltip :content="item.full_path" effect="dark" placement="top">
                                                            <span v-text="item.department_name"></span>
                                                        </el-tooltip>
                                                    </div>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type==='radio'">
                                    <span v-if="row[field.field_key]"
                                          :class="{'is_tag_interaction':field.extend.tag_interaction}"
                                          v-text="row[field.field_key]"></span>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type==='checkbox'">
                                                <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span v-for="item in row[field.field_key]"
                                              :class="{'is_tag_interaction':field.extend.tag_interaction}"
                                              v-text="item">
                                        </span>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type==='checkbox_user_tag'">
                                                <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span v-for="item in row[field.field_key]"
                                              class="is_tag_interaction"
                                              v-text="item.name">
                                        </span>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type==='image'">
                                                <div v-if="row[field.field_key].length" class="table_custom_image_wrap">
                                                    <el-image
                                                            :preview-src-list="row[field.field_key].map(img=>img.file_path)"
                                                            :src="row[field.field_key][0].file_path"
                                                            fit="cover">
                                                    </el-image>
                                                    <el-popover :visible-arrow="false"
                                                                placement="bottom-start"
                                                                popper-class="table_custom_image_popover"
                                                                title=""
                                                                trigger="hover"
                                                                width="254">
                                                        <div slot="reference">
                                                <span v-if="row[field.field_key].length>1"
                                                      class="image_count"
                                                      v-text="`+${row[field.field_key].length-1}`"></span>
                                                        </div>
                                                        <ul class="image_list">
                                                            <li v-for="(img,img_index) in row[field.field_key]"
                                                                :key="img_index"
                                                                class="image_item">
                                                                <el-image
                                                                        :preview-src-list="row[field.field_key].map(img=>img.file_path)"
                                                                        :src="img.file_path"
                                                                        fit="cover">
                                                                </el-image>
                                                            </li>
                                                        </ul>
                                                    </el-popover>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type==='file'">
                                                <div v-if="row[field.field_key].length" class="table_custom_file_wrap">
                                                    <div class="first_file_wrap">
                                                        <div class="file_name_wrap"
                                                             v-text="row[field.field_key][0].file_name"></div>
                                                        <div class="file_right_wrap">
                                                            <el-tooltip content="预览"
                                                                        effect="dark"
                                                                        placement="top">
                                                        <span class="handle_icon_wrap"
                                                              @click="handleClickPreview(row[field.field_key][0])">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                                            </el-tooltip>
                                                            <span class="line"></span>
                                                            <el-tooltip content="下载"
                                                                        effect="dark"
                                                                        placement="top">
                                                        <span class="handle_icon_wrap"
                                                              @click="handleClickDownloadFile(row[field.field_key][0])">
                                                            <i class="iconfont icon-daochu"></i>
                                                        </span>
                                                            </el-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type==='invoice'">
                                                <div v-if="row[field.field_key].length"></div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type==='relate_approve_form'"></div>
                                            <div v-else-if="field.field_type==='id_card'">
                                                <div v-if="row[field.field_key].value" class="custom_id_card_field_wrap">
                                                    <span v-text="row[field.field_key].value"></span>
                                                    <el-popover placement="bottom"
                                                                popper-class="id_card_detail_popper"
                                                                trigger="click"
                                                                width="350">
                                            <span slot="reference" class="handle_icon_wrap">
                                                 <i class="iconfont icon-shenfenzheng"></i>
                                            </span>
                                                        <el-form size="small">
                                                            <el-form-item v-if="row[field.field_key].name" label="姓名"
                                                                          prop="name">
                                                                <span v-text="row[field.field_key].name"></span>
                                                            </el-form-item>
                                                            <el-form-item v-if="row[field.field_key].birthday" label="出生日期"
                                                                          prop="birthday">
                                                                <span v-text="row[field.field_key].birthday"></span>
                                                            </el-form-item>
                                                            <el-form-item v-if="row[field.field_key].address" label="家庭住址"
                                                                          prop="name">
                                                                <span v-text="row[field.field_key].address"></span>
                                                            </el-form-item>
                                                            <el-form-item label="身份证号" prop="value">
                                                                <span v-text="row[field.field_key].value"></span>
                                                            </el-form-item>
                                                        </el-form>
                                                        <img alt=""
                                                             class="ic_card_icon"
                                                             src="https://download.hecoos.com/enlightv/2024-48/2d35b952fcb868047612cca8bf82a615.png">
                                                    </el-popover>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type==='paying_teller'">
                                                <div v-if="row[field.field_key]&&row[field.field_key].text"
                                                     class="custom_paying_teller_field_wrap">
                                                    <span v-text="row[field.field_key].text"></span>
                                                    <el-popover placement="bottom"
                                                                popper-class="paying_teller_detail_popper"
                                                                trigger="click"
                                                                width="350">
                                            <span slot="reference" class="handle_icon_wrap">
                                                 <i class="iconfont icon-zhanghu"></i>
                                            </span>
                                                        <el-form class="custom_detail_form" label-position="top"
                                                                 size="small">
                                                            <el-form-item label="账户类型" prop="account_type">
                                                                <span v-text="row[field.field_key].account_type===1?'个人账户':'对公账户'"></span>
                                                            </el-form-item>
                                                            <el-form-item label="户名" prop="account_name">
                                                                <span v-text="row[field.field_key].account_name"></span>
                                                            </el-form-item>
                                                            <el-form-item label="账号" prop="card_number">
                                                                <span v-text="row[field.field_key].card_number"></span>
                                                            </el-form-item>
                                                            <el-form-item label="所属银行" prop="bank_name">
                                                                <span v-text="row[field.field_key].bank_name"></span>
                                                            </el-form-item>
                                                            <el-form-item v-if="field.extend.bank_branch_is_show"
                                                                          label="银行支行"
                                                                          prop="bank_branch">
                                                                <span v-text="row[field.field_key].bank_branch"></span>
                                                            </el-form-item>
                                                        </el-form>
                                                    </el-popover>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type==='table'">
                                            </div>
                                            <div v-else-if="field.field_type==='radio_customer'">
                                        <span class="link-label"
                                              @click="handleClickRelateHandle('company_detail',row)"
                                              v-text="row.customer_id.text"></span>
                                            </div>
                                            <div v-else-if="field.field_type==='radio_project'">
                                            <span class="link-label"
                                                  @click="handleClickRelateHandle('business_detail',{project_id:row.project_id.value, name:row.project_id.text})"
                                                  v-text="row.project_id.text"></span>
                                            </div>
                                            <div v-else-if="field.field_type==='customer_contact'">
                                                <span v-for="item in row.contact_id" v-text="item.name"></span>
                                            </div>
                                            <div v-else-if="field.field_type==='system'">
                                            </div>
                                            <span v-else
                                                  v-text="row[field.field_key]?row[field.field_key]:'--'"></span>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="operate" fixed="right" width="90">
                                        <template #header>
                                            <span>操作</span>
                                        </template>
                                        <template #default="{ row }">
                                            <div class="flex_wrap">
                                                <el-tooltip v-if="row.order_status===1"  effect="dark"  content="售后" placement="top">
                                                    <span class="handle_icon_wrap"  @click="handleClickRelateHandle('after_sales',row)">
                                                        <i class="iconfont icon-huanhuo1"></i>
                                                    </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-dropdown placement="bottom-end" trigger="click" v-if="projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('business_manage'))">
                                                    <el-tooltip content="更多" effect="dark" placement="top">
                                                        <span class="handle_icon_wrap">
                                                            <i class="iconfont el-icon-more"></i>
                                                        </span>
                                                    </el-tooltip>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <el-dropdown-item @click.native=" handleClickRelateHandle('order_disassociation',row)">取消关联</el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                            </div>
                                        </template>
                                    </vxe-column>

                            </CustomVxeTable>
                            </div>
                            <div v-show="relatedTabActive==='work_order'">
                                <CustomVxeTable
                                        id="relatedWorkOrder"
                                        ref="customTable"
                                        class="custom-table"
                                        :empty-render="{ name: 'NotData' }"
                                        :isShowToolBar="true"
                                        :pagination.sync="pagination"
                                        :reduceHeight="reduceHeight"
                                        :tableData="workOrderTableList"
                                        @handleCurrentChange="handleCurrentChange"
                                        @handleSizeChange="handleSizeChange">
                                    <vxe-column fixed="left" title="工单编号" width="150">
                                        <template #default="{ row }">
                                            <div  class="link-label"  @click="handleClickRelateHandle('work_order_detail',{id:row.id,work_order_num:row.workorder_num})"  v-text="row.workorder_num"></div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column
                                            v-for="field in formInfoList"
                                            :key="field.field_key"
                                            :align="field.align ? 'right' : 'left'"
                                            :field="field.field_key"
                                            :title="field.field_name"
                                            show-overflow
                                            width="200"
                                    >
                                        <template #default="{ row }">
                                            <div v-if="field.field_type === 'contact'">
                                                <div v-if="row[field.field_key].length">
                                                    <div v-for="item in row[field.field_key]" class="custom_contact_field_wrap">
                                                        <PersonnelCard v-if="item.id" :userId="item.id">
                                                            <template slot="container">
                                                                <img
                                                                        :src="item.avatar ? item.avatar : defaultImg"
                                                                        alt=""
                                                                        class="avatar"
                                                                />
                                                                <span class="name" v-text="item.name"></span>
                                                            </template>
                                                        </PersonnelCard>
                                                    </div>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type === 'department'">
                                                <div v-if="row[field.field_key].length">
                                                    <div v-for="item in row[field.field_key]">
                                                        <el-tooltip :content="item.full_path" effect="dark" placement="top">
                                                            <span v-text="item.department_name"></span>
                                                        </el-tooltip>
                                                    </div>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type === 'radio'">
                                    <span
                                            v-if="row[field.field_key]"
                                            :class="{ is_tag_interaction: field.extend.tag_interaction }"
                                            v-text="row[field.field_key]"
                                    ></span>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type === 'checkbox'">
                                                <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span
                                                v-for="item in row[field.field_key]"
                                                :class="{ is_tag_interaction: field.extend.tag_interaction }"
                                                v-text="item"
                                        >
                                        </span>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type === 'checkbox_user_tag'">
                                                <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span
                                                v-for="item in row[field.field_key]"
                                                class="is_tag_interaction"
                                                v-text="item.name"
                                        >
                                        </span>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type === 'image'">
                                                <div v-if="row[field.field_key].length" class="table_custom_image_wrap">
                                                    <el-image
                                                            :preview-src-list="row[field.field_key].map((img) => img.file_path)"
                                                            :src="row[field.field_key][0].file_path"
                                                            fit="cover"
                                                    >
                                                    </el-image>
                                                    <el-popover
                                                            :visible-arrow="false"
                                                            placement="bottom-start"
                                                            popper-class="table_custom_image_popover"
                                                            title=""
                                                            trigger="hover"
                                                            width="254"
                                                    >
                                                        <div slot="reference">
                                                <span
                                                        v-if="row[field.field_key].length > 1"
                                                        class="image_count"
                                                        v-text="`+${row[field.field_key].length - 1}`"
                                                ></span>
                                                        </div>
                                                        <ul class="image_list">
                                                            <li
                                                                    v-for="(img, img_index) in row[field.field_key]"
                                                                    :key="img_index"
                                                                    class="image_item"
                                                            >
                                                                <el-image
                                                                        :preview-src-list="
                                                            row[field.field_key].map((img) => img.file_path)
                                                        "
                                                                        :src="img.file_path"
                                                                        fit="cover"
                                                                >
                                                                </el-image>
                                                            </li>
                                                        </ul>
                                                    </el-popover>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type === 'file'">
                                                <div v-if="row[field.field_key].length" class="table_custom_file_wrap">
                                                    <div class="first_file_wrap">
                                                        <div
                                                                class="file_name_wrap"
                                                                v-text="row[field.field_key][0].file_name"
                                                        ></div>
                                                        <div class="file_right_wrap">
                                                            <el-tooltip content="预览" effect="dark" placement="top">
                                                    <span
                                                            class="handle_icon_wrap"
                                                            @click="handleClickPreview(row[field.field_key][0])"
                                                    >
                                                        <i class="iconfont icon-yanjing"></i>
                                                    </span>
                                                            </el-tooltip>
                                                            <span class="line"></span>
                                                            <el-tooltip content="下载" effect="dark" placement="top">
                                                    <span
                                                            class="handle_icon_wrap"
                                                            @click="handleClickDownloadFile(row[field.field_key][0])"
                                                    >
                                                        <i class="iconfont icon-daochu"></i>
                                                    </span>
                                                            </el-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type === 'invoice'">
                                                <div v-if="row[field.field_key].length"></div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type === 'relate_approve_form'"></div>
                                            <div v-else-if="field.field_type === 'id_card'">
                                                <div v-if="row[field.field_key].value" class="custom_id_card_field_wrap">
                                                    <span v-text="row[field.field_key].value"></span>
                                                    <el-popover
                                                            placement="bottom"
                                                            popper-class="id_card_detail_popper"
                                                            trigger="click"
                                                            width="350"
                                                    >
                                            <span slot="reference" class="handle_icon_wrap">
                                                <i class="iconfont icon-shenfenzheng"></i>
                                            </span>
                                                        <el-form size="small">
                                                            <el-form-item v-if="row[field.field_key].name" label="姓名" prop="name">
                                                                <span v-text="row[field.field_key].name"></span>
                                                            </el-form-item>
                                                            <el-form-item
                                                                    v-if="row[field.field_key].birthday"
                                                                    label="出生日期"
                                                                    prop="birthday"
                                                            >
                                                                <span v-text="row[field.field_key].birthday"></span>
                                                            </el-form-item>
                                                            <el-form-item
                                                                    v-if="row[field.field_key].address"
                                                                    label="家庭住址"
                                                                    prop="name"
                                                            >
                                                                <span v-text="row[field.field_key].address"></span>
                                                            </el-form-item>
                                                            <el-form-item label="身份证号" prop="value">
                                                                <span v-text="row[field.field_key].value"></span>
                                                            </el-form-item>
                                                        </el-form>
                                                        <img
                                                                alt=""
                                                                class="ic_card_icon"
                                                                src="https://download.hecoos.com/enlightv/2024-48/2d35b952fcb868047612cca8bf82a615.png"
                                                        />
                                                    </el-popover>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type === 'paying_teller'">
                                                <div
                                                        v-if="row[field.field_key] && row[field.field_key].text"
                                                        class="custom_paying_teller_field_wrap"
                                                >
                                                    <span v-text="row[field.field_key].text"></span>
                                                    <el-popover
                                                            placement="bottom"
                                                            popper-class="paying_teller_detail_popper"
                                                            trigger="click"
                                                            width="350"
                                                    >
                                            <span slot="reference" class="handle_icon_wrap">
                                                <i class="iconfont icon-zhanghu"></i>
                                            </span>
                                                        <el-form class="custom_detail_form" label-position="top" size="small">
                                                            <el-form-item label="账户类型" prop="account_type">
                                                    <span
                                                            v-text="
                                                            row[field.field_key].account_type === 1
                                                                ? '个人账户'
                                                                : '对公账户'
                                                        "
                                                    ></span>
                                                            </el-form-item>
                                                            <el-form-item label="户名" prop="account_name">
                                                                <span v-text="row[field.field_key].account_name"></span>
                                                            </el-form-item>
                                                            <el-form-item label="账号" prop="card_number">
                                                                <span v-text="row[field.field_key].card_number"></span>
                                                            </el-form-item>
                                                            <el-form-item label="所属银行" prop="bank_name">
                                                                <span v-text="row[field.field_key].bank_name"></span>
                                                            </el-form-item>
                                                            <el-form-item
                                                                    v-if="field.extend.bank_branch_is_show"
                                                                    label="银行支行"
                                                                    prop="bank_branch"
                                                            >
                                                                <span v-text="row[field.field_key].bank_branch"></span>
                                                            </el-form-item>
                                                        </el-form>
                                                    </el-popover>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type === 'table'"></div>
                                            <div v-else-if="field.field_type === 'radio_order'">
                                    <span
                                            class="link-label"
                                            @click="handleClickRelateHandle('order_detail',{order_id:row.order_id.value, order_no:row.order_id.text})"
                                            v-text="row.order_id.text"
                                    ></span>
                                            </div>
                                            <div v-else-if="field.field_type === 'radio_project'">
                                    <span
                                            class="link-label"
                                            @click="handleClickRelateHandle('business_detail',{project_id:row.project_id.value, name:row.project_id.text})"
                                            v-text="row.project_id.text"
                                    ></span>
                                            </div>
                                            <div v-else-if="field.field_type === 'radio_order'">
                                    <span
                                            class="link-label"
                                            @click="handleClickRelateProjectDetail(row)"
                                            v-text="row.order_id.text"
                                    ></span>
                                            </div>
                                            <div v-else-if="field.field_type === 'customer_contact'">
                                                <span v-for="item in row.contact_id" v-text="item.name"></span>
                                            </div>
                                            <div v-else-if="field.field_type === 'workorder_role'">
                                                <div v-if="row[field.field_key].length">
                                                    <div v-for="item in row[field.field_key]" class="custom_contact_field_wrap">
                                                        <PersonnelCard v-if="item.id" :userId="item.id">
                                                            <template slot="container">
                                                                <img
                                                                        :src="item.avatar ? item.avatar : defaultImg"
                                                                        alt=""
                                                                        class="avatar"
                                                                />
                                                                <span class="name" v-text="item.name"></span>
                                                            </template>
                                                        </PersonnelCard>
                                                    </div>
                                                </div>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="field.field_type === 'system'"></div>
                                            <span v-else v-text="row[field.field_key] ? row[field.field_key] : '--'"></span>
                                        </template>
                                    </vxe-column>
                                    <vxe-column title="状态" width="100">
                                        <template #default="{ row }">
                                            <span class="work_order_status" :class="'work_order_status' + row.status">{{ workOrderStatusData[row.status] }}</span>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="operate" fixed="right" width="70">
                                        <template #header>
                                            <span>操作</span>
                                        </template>
                                        <template #default="{ row }">
                                            <div class="flex_wrap">
                                                <el-dropdown placement="bottom-end" trigger="click" v-if="projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('business_manage'))">
                                                    <el-tooltip content="更多" effect="dark" placement="top">
                                                        <span class="handle_icon_wrap">
                                                            <i class="iconfont el-icon-more"></i>
                                                        </span>
                                                    </el-tooltip>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <el-dropdown-item @click.native=" handleClickRelateHandle('work_order_disassociation',row)">取消关联</el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                            </div>
                                        </template>
                                    </vxe-column>
                                </CustomVxeTable>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="财务相关" name="financial_related" v-if="userPermission.includes('all') || userPermission.includes('financial_related_detail')">
                    <div class="project_financial_related_wrap">
                        <div class="financial_data_board">
                            <div class="financial_data_board_title">数据看板</div>
                            <div class="financial_data_board_list">
                                <ul>
                                    <li v-if="userPermission.includes('all') || userPermission.includes('financial_payment')">
                                        <div class="top">回款</div>
                                        <div class="bottom field_flex_wrap">
                                            <div class="field_name ellipsis">项目订单总金额：{{financialBoardData.board.totalPrice}}</div>
                                            <div class="field_name ellipsis">待回款总金额：{{financialBoardData.board.noRepayPrice }}</div>
                                            <div class="field_name ellipsis">实际回款总金额：{{financialBoardData.board.repayPrice}}</div>
                                            <div class="field_name ellipsis">采购退款金额：{{financialBoardData.board.purchaseRefundPrice}}</div>
                                        </div>
                                    </li>
                                    <li v-if="userPermission.includes('all') || userPermission.includes('financial_profit')">
                                        <div class="top">成本/利润</div>
                                        <div class="bottom">
                                            <div class="field_name ellipsis">项目总成本：{{financialBoardData.totalCost}}</div>
                                            <div class="field_name ellipsis">项目实际利润：{{financialBoardData.board.profit}}</div>
                                        </div>
                                    </li>
                                    <li v-if="userPermission.includes('all') || userPermission.includes('financial_payment')">
                                        <div class="top">开票</div>
                                        <div class="bottom">
                                            <div class="field_name ellipsis">已开票金额：{{financialBoardData.board.invoicePrice}}</div>
                                            <div class="field_name ellipsis">待开票金额：{{financialBoardData.board.noInvoicePrice}}</div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="project_related_tab">
                            <span v-if="userPermission.includes('all') || userPermission.includes('financial_payment')" @click="handleClickRelatedTab('payment')" :class="{'active' : relatedTabActive == 'payment'}">回款{{projectDetail.repay_num}}</span>
                            <span v-if="userPermission.includes('all') || userPermission.includes('financial_profit')"  @click="handleClickRelatedTab('cost')" :class="{'active' : relatedTabActive == 'cost'}">成本{{projectDetail.cost_num}}</span>
                            <span v-if="userPermission.includes('all') || userPermission.includes('financial_payment')" @click="handleClickRelatedTab('invoice')" :class="{'active' : relatedTabActive == 'invoice'}">开票{{projectDetail.invoice_num}}</span>
                        </div>
                        <div class="project_related_search flex_js_wrap">
                            <el-input v-if="relatedTabActive == 'payment'" size="small" v-model="payment_related_keyword" placeholder="请输入搜索内容"  clearable ref="search_input_ref" @clear="handleClickBusinessRelatedSearch"  @keyup.enter.native="handleKeyUpEnter" @blur="handleClickBusinessRelatedSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickBusinessRelatedSearch"></i>
                            </el-input>
                            <el-input v-if="relatedTabActive == 'cost'" size="small" v-model="payment_related_keyword" placeholder="请输入搜索内容"  clearable ref="search_input_ref" @clear="handleClickBusinessRelatedSearch"  @keyup.enter.native="handleKeyUpEnter" @blur="handleClickBusinessRelatedSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickBusinessRelatedSearch"></i>
                            </el-input>
                            <el-input v-if="relatedTabActive == 'invoice'" size="small" v-model="payment_related_keyword" placeholder="请输入搜索内容"  clearable ref="search_input_ref" @clear="handleClickBusinessRelatedSearch"  @keyup.enter.native="handleKeyUpEnter" @blur="handleClickBusinessRelatedSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickBusinessRelatedSearch"></i>
                            </el-input>
                            <template v-if="projectDetail.status == 0">
                                <el-button v-if="relatedTabActive == 'payment'" size="small" type="primary" @click="handleClickRelateHandle('payment')">新建回款</el-button>
                                <el-button v-if="relatedTabActive == 'cost' && (userPermission.includes('all') || userPermission.includes('financial_cost'))" size="small" type="primary" @click="handleClickAddCost">新建成本</el-button>
                                <el-button v-if="relatedTabActive == 'invoice'" size="small" type="primary" @click="handleClickRelateHandle('invoice')">新建开票</el-button>
                            </template>
                        </div>

                        <div class="project_related_table">
                            <div v-show="relatedTabActive == 'payment'">
                                <CustomVxeTable v-if="relatedTabActive == 'payment'"
                                        ref="customTable"
                                        class="custom-table"
                                        id="projectRelatedPaymentTable"
                                        :tableData="paymentTableList"
                                        :reduceHeight="reduceHeight"
                                        :isShowToolBar="true"
                                        :empty-render="{ name: 'NotData' }"
                                        :pagination.sync="pagination"
                                        @handleCurrentChange="handleCurrentChange"
                                        @handleSizeChange="handleSizeChange" >
                                    <vxe-column field="receivable_no" fixed="left" title="回款编号" min-width="155">
                                        <template #default="{ row }">
                                            <div class="link-label"  @click="handleClickRelateHandle('payment_detail',row)"  v-text="row.receivable_no"></div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="order_no" title="关联订单"  min-width="155">
                                        <template #default="{ row }">
                                            <div class="link-label"  @click="handleClickRelateHandle('order_detail',row)" v-text="row.order_no"></div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="payment_company_name" title="回款公司"  min-width="155"></vxe-column>
                                    <vxe-column field="uid_info" title="申请人" min-width="120">
                                        <template #default="{ row }">
                                            <div class="custom_contact_field_wrap">
                                                <PersonnelCard v-if="row.uid_info" :userId="row.uid_info.id">
                                                    <template slot="container">
                                                        <img :src="row.uid_info.avatar || defaultImg" alt=""  class="avatar">
                                                        <span class="name" v-text="row.uid_info.name"></span>
                                                    </template>
                                                </PersonnelCard>
                                            </div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="payment_date" title="回款日期" min-width="120"></vxe-column>
                                    <vxe-column field="payment_method_name" title="回款方式" min-width="120"></vxe-column>
                                    <vxe-column field="payment_amount" align="right"  title="回款金额" min-width="120">
                                        <template #default="{ row }">
                                            <div v-text="'¥'+row.payment_amount"></div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="status" title="状态"   min-width="120">
                                        <template #default="{ row }">
                                    <span :class="'payment_status_name_'+row.status" class="status_name"
                                          v-text="row.status_name"></span>
                                            <el-tooltip v-if="row.status===3" :content="row.reject_reason" effect="dark"   placement="top">
                                                 <span class="handle_icon_wrap">
                                                    <i class="iconfont icon-jinggao"></i>
                                                </span>
                                            </el-tooltip>
                                            <el-tooltip v-else-if="row.status===5" :content="row.invalid_reason" effect="dark"  placement="top">
                                                 <span class="handle_icon_wrap">
                                                    <i class="iconfont icon-jinggao"></i>
                                                </span>
                                            </el-tooltip>
                                        </template>
                                    </vxe-column>
                                    <template #empty>
                                        <div class="custom-table-empty">
                                            <p class="custom-table-empty-txt">暂无数据</p>
                                        </div>
                                    </template>
                                </CustomVxeTable>
                            </div>
                            <div v-show="relatedTabActive == 'cost'">
                                <CustomVxeTable v-if="relatedTabActive == 'cost'"
                                                ref="customTable"
                                                class="custom-table"
                                                id="projectRelatedCostTable"
                                                :tableData="costTableList"
                                                :rowId="'custom_id'"
                                                :reduceHeight="reduceHeight"
                                                :isShowToolBar="true"
                                                :empty-render="{ name: 'NotData' }"
                                                 >
                                    <vxe-column field="cost_name" title="成本名称"  min-width="250" show-overflow>
                                        <template #default="{ row }">
                                            <span v-text="row.type != 'custom' ? row.cost_type : row.cost_name"></span>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="price" title="成本金额" align="right" width="170" show-overflow></vxe-column>
                                    <vxe-column field="note" title="成本详情"  min-width="200" show-overflow>
                                        <template #default="{ row }">
                                            <div v-if="row.type == 'custom'">{{row.note}}</div>
                                            <div v-else>
                                                <span v-if="row.type == 'product'"  @click="handleClickRelateHandle('product_cost_detail',row)" class="link-label">详情</span>
                                                <span v-else-if="row.type == 'purchase'"  @click="handleClickRelateHandle('order_purchase_detail',row)" class="link-label">详情</span>
                                                <span v-else-if="row.type == 'payable'"  @click="handleClickRelateHandle('purchase',row)" class="link-label">详情</span>
                                            </div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="name" title="创建人"  width="160" show-overflow>
                                        <template #default="{ row }">
                                            <div class="custom_contact_field_wrap">
                                                <span class="name" v-text="row.name"></span>
<!--                                                <PersonnelCard :userId="row.id" v-if="row.id">-->
<!--                                                    <template slot="container">-->
<!--                                                        <img :src="row.avatar?row.avatar:defaultImg" alt=""-->
<!--                                                             class="avatar">-->
<!--                                                        <span class="name" v-text="row.name"></span>-->
<!--                                                    </template>-->
<!--                                                </PersonnelCard>-->
                                            </div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="created_at" title="创建时间"  width="160" show-overflow> </vxe-column>
                                    <vxe-column field="operate" title="操作"  width="90" fixed="right">
                                        <template #default="{ row }">
                                            <div class="handle_wrap table-operate-icon" v-if="row.type == 'custom' && projectDetail.status == 0  && (userPermission.includes('all') || userPermission.includes('financial_cost'))">
                                                <span class="handle_icon_wrap" @click="handleClickEditCost(row)">
                                                    <i class="iconfont icon-bianji"></i>
                                                </span>
                                                 <span class="line"></span>
                                                <span class="handle_icon_wrap handle_icon_danger_wrap"  @click="handleClickDelCost(row)">
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                            </div>
                                            <span v-else>--</span>
                                        </template>
                                    </vxe-column>
                                    <template #empty>
                                        <div class="custom-table-empty">
                                            <p class="custom-table-empty-txt">暂无数据</p>
                                        </div>
                                    </template>
                                </CustomVxeTable>
                            </div>
                            <div v-show="relatedTabActive == 'invoice'">
                                <CustomVxeTable v-if="relatedTabActive == 'invoice'"
                                                ref="customTable"
                                                class="custom-table"
                                                id="projectRelatedInvoiceTable"
                                                :tableData="invoiceTableList"
                                                :reduceHeight="reduceHeight"
                                                :isShowToolBar="true"
                                                :empty-render="{ name: 'NotData' }"
                                                :pagination.sync="pagination"
                                                @handleCurrentChange="handleCurrentChange"
                                                @handleSizeChange="handleSizeChange" >
                                    <vxe-column field="invoice_no" fixed="left" title="开票编号" min-width="155">
                                        <template #default="{ row }">
                                            <div class="link-label" @click="handleClickRelateHandle('invoice_detail',row)" v-text="row.invoice_no"></div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="relate_id" title="关联订单" min-width="155"  >
                                        <template #default="{ row }">
                                            <div class="link-label"  @click="handleClickRelateHandle('order_detail',row)"  v-text="row.relate_id"></div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="invoice_company_name" title="开票公司" min-width="155"></vxe-column>
                                    <vxe-column field="apply_user_info" title="申请人"  min-width="120">
                                        <template #default="{ row }">
                                            <div class="custom_contact_field_wrap">
                                                <PersonnelCard v-if="row.apply_user_info"  :userId="row.apply_user_info.id">
                                                    <template slot="container">
                                                        <img :src="row.apply_user_info.avatar || defaultImg" alt=""
                                                             class="avatar">
                                                        <span class="name" v-text="row.apply_user_info.name"></span>
                                                    </template>
                                                </PersonnelCard>
                                            </div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="invoice_type_name" title="发票类型" min-width="120"></vxe-column>
                                    <vxe-column field="invoice_amount" align="right"  title="本次开票金额" min-width="120">
                                        <template #default="{ row }">
                                            <div v-text="'¥'+row.invoice_amount"></div>
                                        </template>
                                    </vxe-column>
                                    <vxe-column field="apply_time" title="开票申请时间" min-width="120"></vxe-column>
                                    <vxe-column field="invoice_number" title="发票号码" min-width="120"></vxe-column>
                                    <vxe-column field="status" title="状态"  min-width="120">
                                        <template #default="{ row }">
                                            <div :class="'invoice_status_name_'+row.status" class="status_name"  v-text="row.status_name"></div>
                                        </template>
                                    </vxe-column>
                                    <template #empty>
                                        <div class="custom-table-empty">
                                            <p class="custom-table-empty-txt">暂无数据</p>
                                        </div>
                                    </template>
                                </CustomVxeTable>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="库存相关" name="inventory_related" v-if="userPermission.includes('all') || userPermission.includes('inventory_related_detail')">
                     <div class="project_inventory_related_wrap">
                         <div class="inventory_data_board">
                             <div class="inventory_data_board_title">数据看板</div>
                             <div class="inventory_data_board_list">
                                 <ul>
                                     <li>
                                         <div class="top">出库</div>
                                         <div class="bottom ">
                                             <el-table :data="outInventoryData" border   class="custom_table" height="176">
                                                 <el-table-column label="产品名称" prop="name" show-overflow-tooltip  min-width="194"></el-table-column>
                                                 <el-table-column align="right" label="数量" prop="total_num"  min-width="120"></el-table-column>
                                                 <el-table-column v-if="userPermission.includes('all') || userPermission.includes('inventory_total_cost')" align="right" label="成本总价" prop="total_cost"  min-width="120"></el-table-column>
                                             </el-table>
                                         </div>
                                     </li>
                                     <li>
                                         <div class="top">入库</div>
                                         <div class="bottom">
                                             <el-table :data="inInventoryData" border   class="custom_table" height="176">
                                                 <el-table-column label="产品名称" prop="name" show-overflow-tooltip  min-width="194"></el-table-column>
                                                 <el-table-column align="right" label="数量" prop="total_num"  min-width="120"></el-table-column>
                                                 <el-table-column v-if="userPermission.includes('all') || userPermission.includes('inventory_total_cost')" align="right" label="成本总价" prop="total_cost"  min-width="120"></el-table-column>
                                             </el-table>
                                         </div>
                                     </li>

                                 </ul>
                             </div>
                         </div>
                         <div class="project_related_tab">
                             <span @click="handleClickRelatedTab('add_out_record')" :class="{'active' : relatedTabActive == 'add_out_record'}">出库记录 <i v-if="projectDetail.stock_num">{{projectDetail.stock_num.out_count}}</i></span>
                             <span @click="handleClickRelatedTab('add_in_record')" :class="{'active' : relatedTabActive == 'add_in_record'}">入库记录 <i v-if="projectDetail.stock_num">{{projectDetail.stock_num.in_count}}</i></span>
                         </div>
                         <div class="project_related_search flex_js_wrap">
                             <el-input v-if="relatedTabActive == 'add_out_record'" size="small" v-model="stock_record_related_keyword" placeholder="请输入搜索内容"  clearable ref="search_input_ref" @clear="handleClickBusinessRelatedSearch"  @keyup.enter.native="handleKeyUpEnter" @blur="handleClickBusinessRelatedSearch">
                                 <i slot="suffix" class="el-icon-search" @click="handleClickBusinessRelatedSearch"></i>
                             </el-input>
                             <el-input v-if="relatedTabActive == 'add_in_record'" size="small" v-model="stock_record_related_keyword" placeholder="请输入搜索内容"  clearable ref="search_input_ref" @clear="handleClickBusinessRelatedSearch"  @keyup.enter.native="handleKeyUpEnter" @blur="handleClickBusinessRelatedSearch">
                                 <i slot="suffix" class="el-icon-search" @click="handleClickBusinessRelatedSearch"></i>
                             </el-input>
                             <template v-if="projectDetail.status == 0">
                                 <el-button v-if="relatedTabActive == 'add_out_record'" size="small" type="primary" @click="handleClickRelateHandle('add_out_record')">新建出库</el-button>
                                 <el-button v-if="relatedTabActive == 'add_in_record'" size="small" type="primary" @click="handleClickRelateHandle('add_in_record')">新建入库</el-button>
                             </template>
                         </div>
                         <div class="project_related_table">
                             <div v-show="relatedTabActive == 'add_out_record'">
                                 <CustomVxeTable
                                         ref="customTable"
                                         class="custom-table"
                                         id="alreadyOutWarehouseTable"
                                         :tableData="outRecordTableList"
                                         :reduceHeight="reduceHeight"
                                         :isShowToolBar="true"
                                         :empty-render="{ name: 'NotData' }"
                                         :pagination.sync="pagination"
                                         @handleCurrentChange="handleCurrentChange"
                                         @handleSizeChange="handleSizeChange">
                                     <vxe-column field="approval_id" title="审批编号"  width="110" show-overflow>
                                         <template #default="{ row }">
                                             <span v-if="row.approval_id > 0" class="link-label" @click="handleClickRelateHandle('approval_detail',row)" v-text="row.approval_id"></span>
                                             <span v-else>--</span>
                                         </template>
                                     </vxe-column>
                                     <vxe-column field="log_num" title="出库单编号"  min-width="150" show-overflow>
                                         <template #default="{ row }">
                                             <span class="link-label"  v-text="row.log_num" @click="handleClickRelateHandle('out_record_detail',row)"></span>
                                         </template>
                                     </vxe-column>
                                     <vxe-column field="approval_set_name" title="出库类型"  min-width="140" show-overflow></vxe-column>
                                     <vxe-column field="name" title="业务编号"  width="152" show-overflow>
                                         <template #default="{ row }">
                                             <span v-if="row.related_info" class="link-label" @click="handleClickRelateHandle('stock_related_detail',row)" v-text="row.related_info.related_num"></span>
                                         </template>
                                     </vxe-column>
                                     <vxe-column field="log_products" title="出库产品" min-width="140px"  show-overflow>
                                         <template #default="{ row }">
                                             <el-tooltip  effect="dark" placement="top-start" v-if="row.log_products && row.log_products.length>0">
                                                 <div slot="content" class="log_products_list">
                                                     <p v-for="item in row.log_products" v-text="item"></p>
                                                 </div>
                                                 <div class="flexLeftAutoRight ellipsis" >
                                                     <p  class="leftText ellipsis">
                                                         <span   v-text="row.log_products[0]"></span>
                                                     </p>
                                                     <span  class="rightText" v-text="'+'+ row.log_products.length"></span>
                                                 </div>
                                             </el-tooltip>
                                         </template>
                                     </vxe-column>
                                     <vxe-column field="stocks" title="出库仓库" min-width="140px"  show-overflow>
                                         <template #default="{ row }">
                                             <el-tooltip  effect="dark" placement="top-start" v-if="row.stocks && row.stocks.length>0">
                                                 <div slot="content" class="log_products_list">
                                                     <p v-for="item in row.stocks" v-text="item"></p>
                                                 </div>
                                                 <div class="flexLeftAutoRight ellipsis" >
                                                     <p  class="leftText ellipsis">
                                                         <span   v-text="row.stocks[0]"></span>
                                                     </p>
                                                     <span  class="rightText" v-text="'+'+ row.stocks.length"></span>
                                                 </div>
                                             </el-tooltip>
                                         </template>
                                     </vxe-column>
                                     <vxe-column field="approval_user" title="发起人"  width="108" show-overflow>
                                         <template #default="{ row }">
                                             <userDetailPopover v-if="row.approval_user" :uid="row.approval_user.id">
                                                 <div slot="container">
                                                     <div class="user_head">
                                                         <img :src="row.approval_user && row.approval_user.avatar ? row.approval_user.avatar : defaultImg" alt="" />
                                                         <span v-text="row.approval_user.name"></span>
                                                     </div>
                                                 </div>
                                             </userDetailPopover>
                                         </template>
                                     </vxe-column>
                                     <vxe-column field="creator_info" title="处理人"  width="108" show-overflow>
                                         <template #default="{ row }">
                                             <userDetailPopover v-if="row.creator_info" :uid="row.creator_info.id">
                                                 <div slot="container">
                                                     <div class="user_head">
                                                         <img :src="row.creator_info && row.creator_info.avatar ? row.creator_info.avatar : defaultImg" alt="" />
                                                         <span v-text="row.creator_info.name"></span>
                                                     </div>
                                                 </div>
                                             </userDetailPopover>
                                         </template>
                                     </vxe-column>
                                     <vxe-column field="created_at" title="出库日期"  width="135" show-overflow></vxe-column>
                                     <vxe-column field="operate" width="90" fixed="right">
                                         <template #header>
                                             <span>操作</span>
                                         </template>
                                         <template #default="{ row }">
                                             <div class="table-operate-icon">
                                                 <el-button type="text"  @click="handleClickRelateHandle('out_record_detail',row)">详情</el-button>
                                             </div>
                                         </template>
                                     </vxe-column>
                                     <template #empty>
                                         <div class="custom-table-empty">
                                             <p class="custom-table-empty-txt">暂无数据</p>
                                         </div>
                                     </template>
                                 </CustomVxeTable>
                             </div>
                             <div v-show="relatedTabActive == 'add_in_record'">
                                 <CustomVxeTable
                                         ref="alreadyTableRef"
                                         :loading="loading"
                                         class="custom-table"
                                         id="alreadyInWarehouseTable"
                                         :tableData="inRecordTableList"
                                         :reduceHeight="reduceHeight"
                                         :isShowToolBar="true"
                                         :empty-render="{ name: 'NotData' }"
                                         :pagination.sync="pagination"
                                         @handleCurrentChange="handleCurrentChange"
                                         @handleSizeChange="handleSizeChange" >
                                     <vxe-column field="approval_id" title="审批编号"  width="110" show-overflow>
                                         <template #default="{ row }">
                                             <span v-if="row.approval_id > 0" class="link-label" @click="handleClickRelateHandle('approval_detail',row)" v-text="row.approval_id"></span>
                                             <span v-else>--</span>
                                         </template>
                                     </vxe-column>
                                     <vxe-column field="log_num" title="入库单编号"  min-width="150" show-overflow>
                                         <template #default="{ row }">
                                             <span class="link-label"  @click="handleClickRelateHandle('in_record_detail',row)" v-text="row.log_num"></span>
                                         </template>
                                     </vxe-column>
                                     <vxe-column field="approval_set_name" title="入库类型"  min-width="140" show-overflow></vxe-column>
                                     <vxe-column field="uid" title="业务编号"  width="152" show-overflow>
                                         <template #default="{ row }">
                                             <span v-if="row.related_info && row.related_info.related_num" class="link-label" @click="handleClickRelateHandle('stock_related_detail',row)" v-text="row.related_info.related_num"></span>
                                         </template>
                                     </vxe-column>
                                     <vxe-column field="log_products" title="入库产品" min-width="140px"  >
                                         <template #default="{ row }">
                                             <el-tooltip  effect="dark" placement="top-start" v-if="row.log_products && row.log_products.length>0">
                                                 <div slot="content" class="log_products_list">
                                                     <p v-for="item in row.log_products" v-text="item"></p>
                                                 </div>
                                                 <div class="flexLeftAutoRight ellipsis" >
                                                     <p  class="leftText ellipsis">
                                                         <span   v-text="row.log_products[0]"></span>
                                                     </p>
                                                     <span  class="rightText" v-text="'+'+ row.log_products.length"></span>
                                                 </div>
                                             </el-tooltip>
                                         </template>
                                     </vxe-column>
                                     <vxe-column field="stocks" title="入库仓库"  width="108" show-overflow>
                                         <template #default="{ row }">
                                             <el-tooltip  effect="dark" placement="top-start" v-if="row.stocks && row.stocks.length>0">
                                                 <div slot="content" class="log_products_list">
                                                     <p v-for="item in row.stocks" v-text="item"></p>
                                                 </div>
                                                 <div class="flexLeftAutoRight ellipsis" >
                                                     <p  class="leftText ellipsis">
                                                         <span   v-text="row.stocks[0]"></span>
                                                     </p>
                                                     <span  class="rightText" v-text="'+'+ row.stocks.length"></span>
                                                 </div>
                                             </el-tooltip>
                                         </template>
                                     </vxe-column>

                                     <vxe-column field="approval_user" title="发起人"  width="108" show-overflow>
                                         <template #default="{ row }">
                                             <userDetailPopover v-if="row.approval_user" :uid="row.approval_user.id">
                                                 <div slot="container">
                                                     <div class="user_head">
                                                         <img :src="row.approval_user && row.approval_user.avatar ? row.approval_user.avatar : defaultImg" alt="" />
                                                         <span v-text="row.approval_user.name"></span>
                                                     </div>
                                                 </div>
                                             </userDetailPopover>
                                         </template>
                                     </vxe-column>
                                     <vxe-column field="creator_info" title="处理人"  width="108" show-overflow>
                                         <template #default="{ row }">
                                             <userDetailPopover v-if="row.creator_info" :uid="row.creator_info.id">
                                                 <div slot="container">
                                                     <div class="user_head">
                                                         <img :src="row.creator_info && row.creator_info.avatar ? row.creator_info.avatar : defaultImg" alt="" />
                                                         <span v-text="row.creator_info.name"></span>
                                                     </div>
                                                 </div>
                                             </userDetailPopover>
                                         </template>
                                     </vxe-column>
                                     <vxe-column field="created_at" title="入库日期"  width="135" show-overflow></vxe-column>
                                     <vxe-column field="operate" width="90" fixed="right">
                                         <template #header>
                                             <span>操作</span>
                                         </template>
                                         <template #default="{ row }">
                                             <div class="table-operate-icon">
                                                 <el-button type="text" @click="handleClickRelateHandle('in_record_detail',row)">详情</el-button>
                                             </div>
                                         </template>
                                     </vxe-column>
                                     <template #empty>
                                         <div class="custom-table-empty">
                                             <p class="custom-table-empty-txt">暂无数据</p>
                                         </div>
                                     </template>
                                 </CustomVxeTable>
                             </div>
                         </div>
                     </div>
                </el-tab-pane>
                <el-tab-pane label="关联审批" name="approval_related">
                    <div class="project_approval_related_wrap">
                        <div class="project_related_search flex_js_wrap">
                            <el-input size="small" v-model="approval_related_keyword" placeholder="请输入搜索内容"  clearable ref="search_input_ref" @clear="handleClickBusinessRelatedSearch"  @keyup.enter.native="handleKeyUpEnter" @blur="handleClickBusinessRelatedSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickBusinessRelatedSearch"></i>
                            </el-input>

                            <el-dropdown placement="bottom-end" trigger="click" v-if="projectDetail.status == 0">
                                <el-button size="small" type="primary">新增审批</el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="handleClickRelateHandle('add_approval')">发起审批</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickRelateHandle('relate_approval')">关联审批</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="project_related_table">
                            <CustomVxeTable v-if="activeName == 'approval_related'"
                                            :loading="loading"
                                            ref="customTable"
                                            class="custom-table"
                                            id="approvalTable"
                                            :tableData="approvalTableList"
                                            :reduceHeight="reduceHeight"
                                            :isShowToolBar="true"
                                            :empty-render="{ name: 'NotData' }"
                                            :pagination.sync="pagination"
                                            @handleCurrentChange="handleCurrentChange"
                                            @handleSizeChange="handleSizeChange">
                                <vxe-column field="relate_id" title="审批编号"  width="120" show-overflow>
                                    <template #default="{ row }">
                                        <span class="link-label" @click="handleClickRelateHandle('approval_detail',{approval_id:row.relate_id})" v-text="'ID:' + row.relate_id"></span>
                                    </template>
                                </vxe-column>
                                <vxe-column field="approve_title" title="审批标题"  min-width="150" show-overflow>
                                    <template #default="{ row }">
                                        <span v-if="row.approval_detail && row.approval_detail.approve_title" v-text="row.approval_detail.approve_title.name"></span>
                                    </template>
                                </vxe-column>

                                <vxe-column field="approval_detail" title="发起人"  width="108" show-overflow>
                                    <template #default="{ row }">
                                        <userDetailPopover v-if="row.approval_detail && row.approval_detail.user && row.approval_detail.user" :uid="row.approval_detail.user.id">
                                            <div slot="container">
                                                <div class="user_head">
                                                    <img :src="row.approval_detail.user.avatar ? row.approval_detail.user.avatar : defaultImg" alt="" />
                                                    <span v-text="row.approval_detail.user.name"></span>
                                                </div>
                                            </div>
                                        </userDetailPopover>
                                    </template>
                                </vxe-column>
                                <vxe-column field="user" title="关联人"  width="108" show-overflow>
                                    <template #default="{ row }">
                                        <userDetailPopover v-if="row.user" :uid="row.user.id">
                                            <div slot="container">
                                                <div class="user_head">
                                                    <img :src="row.user && row.user.avatar ? row.user.avatar : defaultImg" alt="" />
                                                    <span v-text="row.user.name"></span>
                                                </div>
                                            </div>
                                        </userDetailPopover>
                                    </template>
                                </vxe-column>
                                <vxe-column field="created_at" title="申请日期"  width="155" show-overflow>
                                    <template #default="{ row }">
                                        <span v-if="row.approval_detail && row.approval_detail.created_at" v-text="row.approval_detail.created_at"></span>
                                    </template>
                                </vxe-column>
                                <vxe-column field="operate" width="150" fixed="right">
                                    <template #header>
                                        <span>操作</span>
                                    </template>
                                    <template #default="{ row }">
                                        <div class="table-operate-icon">
                                            <el-button type="text"  @click="handleClickRelateHandle('approval_detail',{approval_id:row.relate_id})">查看详情</el-button>
                                            <el-button type="text" v-if="projectDetail.status == 0"  @click="handleClickRelateHandle('approval_disassociation',row)">取消关联</el-button>
                                        </div>
                                    </template>
                                </vxe-column>
                                <template #empty>
                                    <div class="custom-table-empty">
                                        <p class="custom-table-empty-txt">暂无数据</p>
                                    </div>
                                </template>
                            </CustomVxeTable>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="项目成员" name="project_members" v-if="userPermission.includes('all') || userPermission.includes('member_related_detail')">
                    <div class="project_members_wrap">
                        <div class="project_related_search flex_js_wrap">
                            <el-input size="small" v-model="project_members_keyword" placeholder="请输入搜索内容"  clearable ref="search_input_ref"  @clear="handleClickBusinessRelatedSearch"  @keyup.enter.native="handleKeyUpEnter" @blur="handleClickBusinessRelatedSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickBusinessRelatedSearch"></i>
                            </el-input>
                            <el-button v-if="projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('member_operate'))" size="small" type="primary" @click="handleClickRelateHandle('add_member')">添加成员</el-button>
                        </div>
                        <div class="project_related_table">
                            <CustomVxeTable v-if="activeName == 'project_members'"
                                    :loading="loading"
                                    ref="customTable"
                                    class="custom-table"
                                    id="membersTable"
                                    :tableData="membersTableList"
                                    :reduceHeight="reduceHeight"
                                    :isShowToolBar="true"
                                    :empty-render="{ name: 'NotData' }"
                                    :pagination.sync="pagination"
                                    @handleCurrentChange="handleCurrentChange"
                                    @handleSizeChange="handleSizeChange">

                                <vxe-column field="project_manage_id" title="项目成员"  min-width="108" show-overflow>
                                    <template #default="{ row }">
                                        <div v-if="row.member_role == '项目负责人'">
                                            <userDetailPopover v-if="row.members && row.members[0] && row.members[0].member_user" :uid="row.members[0].member_user.id">
                                                <div slot="container">
                                                    <div class="user_head">
                                                        <img :src="row.members[0].member_user && row.members[0].member_user.avatar ? row.members[0].member_user.avatar : defaultImg" alt="" />
                                                        <span v-text="row.members[0].member_user.name"></span>
                                                    </div>
                                                </div>
                                            </userDetailPopover>
                                        </div>
                                        <div v-else>
                                            <span v-if="row.members" v-text="row.members.map(map => map.member_user.name).join()"></span>
                                        </div>

                                    </template>
                                </vxe-column>
                                <vxe-column field="member_role" title="角色名称"  min-width="135" show-overflow></vxe-column>
                                <vxe-column field="created_at22" title="可见范围权限"  min-width="135" show-overflow>
                                    <template #default="{ row }">
                                       <span v-if="row.permission_range.indexOf('all') >-1">全部权限</span>
                                       <span v-else v-text="row.permission_range_text"></span>
                                    </template>
                                </vxe-column>
                                <vxe-column field="operate" width="90" fixed="right">
                                    <template #header>
                                        <span>操作</span>
                                    </template>
                                    <template #default="{ row }">
                                        <div class="handle_wrap table-operate-icon" v-if="projectDetail.status == 0">
                                            <span v-if="row.member_role == '项目负责人' && userPermission.includes('all') " class="handle_icon_wrap" @click="handleClickChangePerson()">
                                                <i class="iconfont icon-fenpei"></i>
                                            </span>
                                            <template v-else-if="userPermission.includes('all') || userPermission.includes('member_operate')">
                                                 <span class="handle_icon_wrap" @click="handleClickRelateHandle('edit_member',row)">
                                                    <i class="iconfont icon-bianji"></i>
                                                 </span>
                                                <span class="line"></span>
                                                <span class="handle_icon_wrap handle_icon_danger_wrap"  @click="handleClickRelateHandle('del_member',row)">
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                            </template>
                                        </div>
                                    </template>
                                </vxe-column>
                                <template #empty>
                                    <div class="custom-table-empty">
                                        <p class="custom-table-empty-txt">暂无数据</p>
                                    </div>
                                </template>
                            </CustomVxeTable>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="项目资料" name="project_file" v-if="userPermission.includes('all') || userPermission.includes('project_file_detail')">
                    <div class="project_file_wrap">
                        <div class="project_related_search flex_js_wrap">
                            <el-input size="small" v-model="project_file_keyword" placeholder="请输入搜索内容"  clearable ref="search_input_ref" @clear="handleClickBusinessRelatedSearch"  @keyup.enter.native="handleKeyUpEnter" @blur="handleClickBusinessRelatedSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickBusinessRelatedSearch"></i>
                            </el-input>
                            <el-button v-if="projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('project_file_operate'))" class="project_upload_button" size="small" type="primary">
                                上传文件
                                <input  class="upload_input" type="file"  @change="handleUploadChange($event)">
                            </el-button>
                        </div>
                        <div class="project_related_table">
                            <CustomVxeTable v-if="activeName == 'project_file'"
                                    :loading="loading"
                                    ref="customTable"
                                    class="custom-table"
                                    id="fileTable"
                                    :tableData="fileTableList"
                                    :reduceHeight="reduceHeight"
                                    :isShowToolBar="true"
                                    :empty-render="{ name: 'NotData' }"
                                    :pagination.sync="pagination"
                                    @handleCurrentChange="handleCurrentChange"
                                    @handleSizeChange="handleSizeChange">

                                <vxe-column field="file_name" title="文件名称"  min-width="250" show-overflow>
                                    <template #default="{ row }">
                                        <ul class="upload_file_list  upload_file_list_detail">
                                            <li class="upload_file_item"   style="padding: 4px 0 0 0;background: transparent">
                                                <div class="file_left_wrap" style="max-width: calc(100% - 74px);">
                                                    <img alt="" src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png" class="file_img">
                                                    <div class="file_info_wrap">
                                                        <p class="file_name ellipsis" v-text="row.file_name"></p>
                                                    </div>
                                                </div>
                                                <div class="file_right_wrap" style="min-width: 70px" v-if="row.type !='quotation'">
                                                    <el-tooltip content="预览"  effect="dark" placement="top">
                                                        <span class="handle_icon_wrap" @click="handleClickPreview(row)">
                                                            <i class="iconfont icon-yanjing"></i>
                                                        </span>
                                                    </el-tooltip>
                                                    <span class="line"></span>
                                                    <el-tooltip content="下载"  effect="dark" placement="top">
                                                        <span class="handle_icon_wrap"
                                                              @click="handleClickDownloadFile(row)">
                                                            <i class="iconfont icon-daochu"></i>
                                                        </span>
                                                    </el-tooltip>
                                                </div>
                                            </li>
                                        </ul>
                                    </template>
                                </vxe-column>
                                <vxe-column field="created_at" title="来源"  width="250" show-overflow>
                                    <template #default="{ row }">
                                        <span v-if="row.type == 'project_manage'">项目</span>
                                        <span v-if="row.type == 'quotation'">报价单 <span class="link-label" @click="handleClickRelateHandle('business_detail',{project_id:row.type_id,name:row.type_name})" v-if="row.type_num" v-text="row.type_num"></span></span>
                                        <span v-if="row.type == 'order'">订单合同 <span class="link-label" @click="handleClickRelateHandle('order_detail',{order_id:row.type_id,order_num:row.type_name})" v-if="row.type_num" v-text="row.type_num"></span></span>
                                        <span v-if="row.type == 'workorder'">工单 <span class="link-label" @click="handleClickRelateHandle('business_detail',{id:row.type_id,work_order_num:row.type_name})" v-if="row.type_num" v-text="row.type_num"></span></span>
                                    </template>
                                </vxe-column>
                                <vxe-column field="uid" title="创建人"  min-width="135" show-overflow>
                                    <template #default="{ row }">
                                        <userDetailPopover v-if="row.user" :uid="row.user.id">
                                            <div slot="container">
                                                <div class="user_head">
                                                    <img :src="row.user.avatar ? row.user.avatar : defaultImg" alt="" />
                                                    <span v-text="row.user.name"></span>
                                                </div>
                                            </div>
                                        </userDetailPopover>
                                    </template>
                                </vxe-column>
                                <vxe-column field="created_at" title="创建时间"  min-width="135" show-overflow></vxe-column>
                                <vxe-column field="operate" width="80" fixed="right">
                                    <template #header>
                                        <span>操作</span>
                                    </template>
                                    <template #default="{ row }">
                                        <div class="handle_wrap table-operate-icon">
                                            <span v-if="row.type == 'project_manage' && projectDetail.status == 0 && (userPermission.includes('all') || userPermission.includes('project_file_operate'))" class="handle_icon_wrap handle_icon_danger_wrap"  @click="handleClickDelFile(row)">
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                            <span v-if="row.type =='quotation'" class="link-label" @click="handleClickRelateHandle('view_the_quotation',{project_quotation_id:row.file_path, title:row.file_name})">查看详情</span>
                                        </div>
                                    </template>
                                </vxe-column>
                                <template #empty>
                                    <div class="custom-table-empty">
                                        <p class="custom-table-empty-txt">暂无数据</p>
                                    </div>
                                </template>
                            </CustomVxeTable>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>

       <RecordTpl  v-if="recordDialog" :recordDialog.sync="recordDialog" :projectId="projectId" :recordId="recordId" @success="getProjectLogList"/>
       <CostTpl  v-if="costDialog" :costDialog.sync="costDialog" :projectId="projectId" :costId="costId" @success="costSuccess"/>
       <ChangeThePerson v-if="changeThePersonDialogVisible" :projectId="projectId"  @success="changeThePersonSuccess" :dialogVisible.sync="changeThePersonDialogVisible"/>
       <ProjectTpl :projectAddVisible.sync="projectEditVisible" v-if="projectEditVisible"  :projectId="projectId" @success="getProjectDetail"/>
       <RelatedHandle ref="relatedHandle" @relatedHandleSuccess="relatedHandleSuccess"/>
       <el-image ref="preview_img" :preview-src-list="previewImgList" :src="previewImgSrc" style="display:none"></el-image>
   </div>
</template>
<script>
import {
    ProjectManageDel,
    ProjectManageFinish,
    ProjectManageFinishCancel,
    ProjectManageClose,
    ProjectManageCloseCancel,
    ProjectManageDetail,
    getFormFields,
    projectList,
    ProjectLogList,
    ProjectLogDel,
    ProjectFileList,
    ProjectFileAdd,
    ProjectFileDel,
    ProjectManageMemberList,
    orderList,
    ProjectManageCostList,
    ProjectManageCostDel,
    orderInvoiceSummary,
    orderRepaymentList,
    ProjectManageFinancialBoard,
    ProjectManageStockCostDetail,
    stockInList,
    stockOutList,
    workOrderList,
    ProjectManageApprovalList,
    ProjectManagePermission
} from "@/api"
import {formatFileSize,tableDataFieldShow,getFileType,formatToNumber} from "@/utils";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import {pagination} from '@/mixins'
import * as echarts from "echarts";
import userDetailPopover from "@/components/pComponents/userDetailPopover";
import RecordTpl from "./component/record_tpl";
import CostTpl from "./component/cost_tpl";
import ProjectTpl from "./component/project_tpl.vue";
import ChangeThePerson from "./component/change_the_person"
import CustomVxeTable from "@/components/pComponents/vxe-table";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import RelatedHandle from "./component/related_handle.vue";

export default {
    name: 'ProjectDetail',
    components: {
        CustomVxeTable,
        PersonnelCard,
        userDetailPopover,
        RecordTpl,
        CostTpl,
        ChangeThePerson,
        ProjectTpl,
        RelatedHandle
    },
    mixins: [pagination],
    data() {
        return {
            loading:false,
            detailLoading:false,
            projectId:0,
            projectDetail:{},
            logList:[],
            isLogMore:false,
            defaultImg: require("@/assets/images/default.jpg"),
            elaborateOrRetract:false,
            activeName:'project_board',
            listMode:'time_axis',
            progressElaborateOrRetract:false,
            recordDialog:false, //新增记录
            recordId:0,//记录Id
            costMode:'pie',
            myChartPie:null,
            myChartBar:null,
            costDialog:false,//新建成本
            costId:0,//成本Id

            related_keyword:'', //相关筛选
            business_related_keyword:'',//商机筛选
            // order_related_keyword:'',//订单筛选
            // work_order_related_keyword:'',//工单筛选
            payment_related_keyword :'', //回款筛选
            // cost_related_keyword:'', //成本筛选
            // invoice_related_keyword:'', //开票筛选
            stock_record_related_keyword:'', //库存记录筛选
            // out_record_related_keyword:'', //出库记录筛选
            // in_record_related_keyword:'',//入库记录筛选
            approval_related_keyword:'', //关联审批筛选
            project_members_keyword:'',//项目成员筛选
            project_file_keyword:'', //项目资料筛选


            relatedTabActive:'add_out_record',
            businessTableList:[],//商机列表
            orderTableList:[],//订单列表
            workOrderTableList:[],//工单列表
            formInfoList:[], //字段
            max_height:0,
            reduceHeight:0,
            changeThePersonDialogVisible:false,//更改负责人
            projectEditVisible:false,

            paymentTableList:[],//回款列表
            costTableList:[],//成本列表
            invoiceTableList:[],//开票列表
            outInventoryData:[], //数据看板-出库
            inInventoryData:[], //数据看板-入库
            outRecordTableList:[],//出库记录
            inRecordTableList:[],//出库记录
            approvalTableList:[],//审批列表
            membersTableList:[],//成员列表
            fileTableList:[],//附件列表
            previewImgList:[],
            previewImgSrc:'',
            financialBoardData:{
                board:{
                    noRepayPrice:'0.00',
                    profit:'0.00',
                    purchaseRefundPrice:'0.00',
                    repayPrice:'0.00',
                    totalPrice:'0.00',
                    invoicePrice: "0.00",
                    noInvoicePrice: "0.00"
                },
                repayPricePercentage:0.00,//已回款比例
                cost:[],
                totalCost:'0.00',
            }, //财务看板
            workOrderStatusData: {
                0: '审批中',
                1: '待指派',
                2: '待出发',
                3: '待实施',
                4: '实施中',
                5: '实施完成',
                6: '已结单',
                7: '已评价',
                '-1': '已拒绝',
                '-2': '已撤销',
                '-3': '已关闭'
            },
            userPermission:[]

        }
    },
    computed: {

    },
    mounted() {
        if(!this.detailLoading){
            this.getProjectManagePermission()
        }
        window.addEventListener('resize', this.getMaxHeight);
        this.getMaxHeight()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getMaxHeight);
    },
    created() {
        this.projectId = Number(this.$route.query.id)

    },
    // 从上一页返回的时候刷新
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.handleClickBusinessRelatedSearch();
            if(!vm.detailLoading){
                vm.getProjectManagePermission();
            }

        });
    },
    methods:{
        // 获取个人权限
        getProjectManagePermission(){
            this.detailLoading = true
            ProjectManagePermission({ project_manage_id:this.projectId }).then((res) => {
                if(res.code == 200){
                    let {data} = res
                    this.userPermission = data
                    this.getProjectDetail()
                }
            });
        },
        // 获取项目详情
        getProjectDetail(only = false){
            this.detailLoading = true
            ProjectManageDetail({ id:this.projectId }).then((res) => {
                if (res.code == 200) {
                    this.projectDetail = res.data
                    this.projectDetail.business_number = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='project').length : 0
                    this.projectDetail.order_number = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='order').length : 0
                    this.projectDetail.work_order_number = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='workorder').length : 0
                    this.projectDetail.order_list = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='order').map((item)=> {
                        return {order_id: item.relate_id, order_num: item.relate_num}
                    }) : []
                    this.projectDetail.business_list = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='project').map((item)=> {
                        return {project_id: item.relate_id, project_name: item.relate_detail.name}
                    }) : []
                    this.projectDetail.work_order_list = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='workorder').map((item)=> {
                        return {workorder_id: item.relate_id, workorder_num: item.relate_num}
                    }) : []
                    this.projectDetail.approval_list = this.projectDetail.relates ? this.projectDetail.relates.filter(item=>item.relate_type==='approval').map((item)=> {
                        return {approval_id: item.relate_id,}
                    }) : []
                    if(only == false){
                        this.getProjectLogList()
                        this.getProjectManageFinancialBoard()
                    }
                    this.detailLoading = false
                }else{
                    this.detailLoading = false
                }

            });
        },
        // 获取项目进度列表
        getProjectLogList(){
            let postData = {
                id: this.projectId,
            }
            ProjectLogList(postData).then(res => {
                if (res.code === 200) {
                    this.logList  = res.data || []
                    this.$nextTick(() =>{
                        const element = this.$refs.project_board_progress_time_axis;
                        const element2 = this.$refs.project_board_progress;
                        if (element && element2) {
                            if(element2.offsetHeight - element.offsetHeight < 104){
                                this.isLogMore = true
                            }
                            element.scrollLeft = element.scrollWidth;
                        }

                    })
                }
            })
        },
        // 获取项目看板 - 财务看板
        getProjectManageFinancialBoard(){
            let postData = {
                project_manage_id: this.projectId,
            }
            ProjectManageFinancialBoard(postData).then(res => {
                if (res.code === 200) {
                    let {data} = res
                    this.financialBoardData = data
                    let repayPricePercentage = Number(data.board.repayPrice) / Number(data.board.totalPrice) * 100
                    repayPricePercentage = (isNaN(repayPricePercentage) || repayPricePercentage < 0) ? 0 : repayPricePercentage
                    this.financialBoardData.repayPricePercentage = formatToNumber(repayPricePercentage,2) == Infinity ? 0 : formatToNumber(repayPricePercentage,2)
                    if(this.myChartPie){
                        this.myChartPie.dispose();
                        this.myChartPie = null;
                    }
                    if(this.myChartBar){
                        this.myChartBar.dispose();
                        this.myChartBar = null;
                    }
                    if(this.financialBoardData.cost.filter(item=>item.cost >0).length == 0 || (!this.userPermission.includes('all') && !this.userPermission.includes('financial_profit'))){
                        return false
                    }
                    this.$nextTick(() => {
                        if(this.costMode == 'pie'){
                            this.getEchartsPie('container1', this.financialBoardData.cost.filter(item=>item.cost >0) )
                        }else{
                            this.getEchartsBar('container2',  this.financialBoardData.cost.filter(item=>item.cost >0))
                        }
                    })
                }
            })
        },
        // 获取项目成本
        getProjectManageCostList(){
            let postData = {
                project_manage_id: this.projectId,
                keyword: this.payment_related_keyword,
            }
            ProjectManageCostList(postData).then(res => {
                if (res.code === 200) {
                    let {data} = res
                    data.forEach((item,key)=>{
                     this.$set(item,'custom_id',key + 1)
                    })
                    this.costTableList = data || []
                }
            })
        },

        getMaxHeight(){
            this.$nextTick(() => {
                if(this.$refs.project_detail_info && this.$refs.project_detail_wrap){
                    let wrapOffsetHeight = this.$refs.project_detail_wrap.offsetHeight
                    let infoOffsetHeight = this.$refs.project_detail_info.offsetHeight
                    this.max_height =  wrapOffsetHeight - infoOffsetHeight
                    this.reduceHeight = (this.activeName == 'approval_related' || this.activeName == 'project_members') ? infoOffsetHeight + 218 : this.activeName == 'project_file' ? infoOffsetHeight + 172: infoOffsetHeight + 258
                }
            })

        },
        // 展开收起
        handleClickElaborateOrRetract(){
            this.elaborateOrRetract = !this.elaborateOrRetract
            this.getMaxHeight()
        },
        // 项目进度展开收起
        handleClickProgressElaborateOrRetract(){
            this.progressElaborateOrRetract = !this.progressElaborateOrRetract
        },
        // 项目进度时间轴-左
        handleClickTimeAxisPrev(){
            const container = this.$refs.project_board_progress_time_axis;
            const boxWidth = container.clientWidth;
            container.scrollLeft = Math.max(container.scrollLeft - boxWidth, 0);
        },
        // 项目进度时间轴-右
        handleClickTimeAxisNext(){
            const container = this.$refs.project_board_progress_time_axis;
            const boxWidth = container.clientWidth;
            const maxScrollLeft = container.scrollWidth - boxWidth;
            container.scrollLeft = Math.min(container.scrollLeft + boxWidth, maxScrollLeft);
        },
        // 切换tab
        handleClickTab(value){

            if(this.activeName == 'project_board'){
                this.getProjectDetail()
            }else if(this.activeName == 'business_related'){
                this.relatedTabActive = 'business'
                let field_form = this.relatedTabActive == 'business' ? 'projects' : this.relatedTabActive == 'order' ? 'orders' : this.relatedTabActive
                this._getFromFields(field_form)
            }else if(this.activeName == 'financial_related'){ //财务相关
                if(this.userPermission.includes('all') || this.userPermission.includes('financial_payment')){
                    this.relatedTabActive = 'payment'
                    this.getProjectDetail(true)
                    this.getProjectManageFinancialBoard()
                    this.getOrderRepaymentList()
                }else if(this.userPermission.includes('financial_profit')){
                    this.relatedTabActive = 'cost'
                    this.getProjectDetail(true)
                    this.getProjectManageFinancialBoard()
                    this.getProjectManageCostList()
                }else{
                    this.relatedTabActive = ''
                }
            }else if(this.activeName == 'inventory_related'){
                this.relatedTabActive = 'add_out_record'
                this.getProjectManageStockCostDetail()
                this.getStockOutList()
            }else if(this.activeName == 'approval_related'){
                this.getProjectManageApprovalList()
            }else if(this.activeName == 'project_members'){
                this.getProjectManageMemberList()
            }else if(this.activeName == 'project_file'){
                this.getProjectFileList()
            }
            this.getMaxHeight() //盒子高度计算
        },
        // 切换时间轴、甘特图
        handleClickProjectListType(mode){
            this.listMode = mode
        },
        updatedDate(date,logTime){
            let time = logTime.split(' ')[0]
            if(date != time){
                return `（${time}）`
            }else{
                return ''
            }
        },
        // 新增记录
        handleClickAddProjectRecord(){
            this.recordId = 0
            this.recordDialog = true
        },
        // 编辑记录
        handleClickEditProjectRecord(id){
            this.recordId = id
            this.recordDialog = true
        },
        // 删除记录
        handleClickDelProjectRecord(id){
            const h = this.$createElement;
            this.$msgbox({
                title: '删除记录',
                message: h('div', null, [
                    h('span', null, '确定要删除吗？'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                ProjectLogDel({id:id}).then(res => {
                    if (res.code === 200) {
                        this.$message.success(res.message)
                        this.getProjectLogList()
                    }
                }).catch(() => {

                })
            }).catch(() => {

            })
        },
        // 项目成本切换展示
        handleClickCostCharts(mode){
          this.costMode = mode
          this.$nextTick(() => {
              if(this.myChartPie){
                  this.myChartPie.dispose();
                  this.myChartPie = null;
              }
              if(this.myChartBar){
                  this.myChartBar.dispose();
                  this.myChartBar = null;
              }
              if(this.financialBoardData.cost.filter(item=>item.cost >0).length == 0){
                  return false
              }
              if(mode == 'pie'){
                  this.getEchartsPie('container1', this.financialBoardData.cost.filter(item=>item.cost >0) )
              }else{
                  this.getEchartsBar('container2',  this.financialBoardData.cost.filter(item=>item.cost >0))
              }
          })
        },
        // 新建成本
        handleClickAddCost(){
            this.costId = 0
            this.costDialog = true
        },
        // 编辑成本
        handleClickEditCost(item){
            this.costId = Number(item.id)
            this.costDialog = true
        },
        // 成本新增编辑完毕回调
        costSuccess(){
            if(this.activeName == 'project_board'){
                this.getProjectManageFinancialBoard()
            }else{
                this.getProjectManageCostList()
            }
            this.getProjectDetail(true)
        },
        // 删除成本
        handleClickDelCost(item){
            const h = this.$createElement;
            this.$msgbox({
                title: '删除成本',
                message: h('div', null, [
                    h('span', null, '确定要删除吗？删除后该成本金额将清空'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                ProjectManageCostDel({id:item.id}).then(res => {
                    if (res.code === 200) {
                        this.$message.success(res.message)
                        this.costSuccess()
                    }
                })
            }).catch(() => {

            })
        },
        generateColors(count) {
            const colors = [];
            for (let i = 0; i < count; i++) {
                const hue = (i * 360 / count) % 360; // 色相均匀分布
                const saturation = 50; // 饱和度降低到 50%
                const lightness = 60; // 亮度调高到 60%
                colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
            }
            return colors;
        },
        // 获取饼图
        getEchartsPie(id, data) {
            let pieData = data.map((item) => {
                return {
                    value: item.cost,
                    name: item.cost_name,
                    rate: item.rate,
                    id:item.id
                };
            });
            let that = this;
            var chartDom = document.getElementById(id);
            this.myChartPie = echarts.init(chartDom);
            var option;
            option = {
                color: this.generateColors(pieData.length),
                title: {},
                grid: {
                    left: '0px',
                    right: '0%',
                    bottom: '0px',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'item',
                    enterable: true,
                    zIndex: 1000, // 提高 tooltip 的层级
                    backgroundColor: "#fffffff",
                    padding: 12,
                    position: function (point, params, dom, rect, size) {
                        return [  point[0], point[1]];
                    },
                    formatter: function (params) {
                        let handleHml = `<div class="custom_chart_tooltip">
                                <div class="tooltip_title flex_js_wrap">
                                    <p class="ellipsis">${params.name}</p>
                                    <div class="handle_wrap">
                                     <span class="handle_icon_wrap " >
                                          <i class="iconfont icon-bianji tooltip_btn" data-type="edit" data-id="${params.data.id}"></i>
                                      </span>
                                      <span class="handle_icon_wrap handle_icon_danger_wrap " >
                                          <i class="iconfont icon-shanchu1 tooltip_btn" data-type="del" data-id="${params.data.id}"></i>
                                      </span>
                                    </div>
                                </div>
                                <div class="tooltip_content flex_js_wrap"><span>${params.marker} ${params.value}</span> <span>${params.percent}%</span></div>
                        </div>`
                        let html = `<div class="custom_chart_tooltip">
                                <div class="tooltip_title flex_js_wrap">
                                    <p class="ellipsis">${params.name}</p>
                                </div>
                                <div class="tooltip_content flex_js_wrap"><span>${params.marker} ${params.value}</span> <span>${params.percent}%</span></div>
                        </div>`
                        return params.data.id ? handleHml : html
                    }
                },
                series: [
                    {

                        type: 'pie',
                        label: {
                            formatter: function (params) {
                                return `{marker|●} ${params.name}\n    ${params.value}`;
                            },
                            rich: {
                                marker: {
                                    fontSize: 14,
                                }
                            },
                            position: 'outside'
                        },
                        labelLine: {
                            length: 20,

                        },
                        radius: '50%',
                        data: pieData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    },
                    {
                        type: 'pie',
                        radius: '50%',
                        label: {
                            show: true,
                            position: 'inside',
                            formatter: function (params) {
                                // 根据条件决定是否显示
                                return params.percent > 9 ? `${params.percent}%` : '';
                            },
                            color: '#fff'
                        },
                        data: pieData
                    }
                ]
            };
            option && this.myChartPie.setOption(option, true);
            this.myChartPie.getDom().addEventListener('click', that.handleChartClick);
        },
        handleChartClick(e){
            let that = this
            if(that.projectDetail.status != 0){
               return  this.$message.error(`项目已${that.projectDetail.status == 1 ? '完结' : '关闭'}，无法操作`)
            }
            if(!that.userPermission.includes('all') && !that.userPermission.includes('financial_cost')){
                return  this.$message.error(`没有操作权限，无法操作`)
            }
            if (e.target && e.target.classList.contains('tooltip_btn')) {
                const type = e.target.getAttribute('data-type');
                const id = e.target.getAttribute('data-id');
                console.log(id);
                // 处理按钮点击事件
                if(type == 'edit'){
                    that.handleClickEditCost({id:id})
                }else{
                    that.handleClickDelCost({id:id})
                }
                const tooltipElement = document.querySelector(`.custom_chart_tooltip`);
                if (tooltipElement) {
                    tooltipElement.style.display = 'none';
                }

            }
        },
        // 获取柱状图
        getEchartsBar(id, data){
            let barData = data.map((item) => {
                return {
                    value: item.cost,
                    name: item.cost_name,
                    rate: item.rate,
                    id:item.id
                };
            });
            var that = this
            var chartDom = document.getElementById(id);
            this.myChartBar = echarts.init(chartDom);
            var option;
            option = {
                color:['#2990FF'],
                grid: {
                    left: '30px',
                    right: '0%',
                    bottom: '10px',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'item',
                    enterable: true,
                    zIndex: 1000, // 提高 tooltip 的层级
                    backgroundColor: "#fffffff",
                    padding: 12,
                    position: function (point, params, dom, rect, size) {
                        let x = params.dataIndex > 2 ? point[0]-size.contentSize[0] : point[0]
                        return [ x, point[1]];
                    },
                    formatter: function (params) {
                        let handleHml = `<div class="custom_chart_tooltip">
                                <div class="tooltip_title flex_js_wrap">
                                    <p class="ellipsis">${params.name}</p>
                                    <div class="handle_wrap">
                                     <span class="handle_icon_wrap " >
                                          <i class="iconfont icon-bianji tooltip_btn" data-type="edit" data-id="${params.data.id}"></i>
                                      </span>
                                      <span class="handle_icon_wrap handle_icon_danger_wrap ">
                                          <i class="iconfont icon-shanchu1 tooltip_btn"  data-type="del" data-id="${params.data.id}"></i>
                                      </span>
                                    </div>
                                </div>
                                <div class="tooltip_content flex_js_wrap"><span>${params.marker} ${params.value}</span> <span>${params.data.rate}%</span></div>
                        </div>`
                        let html = `<div class="custom_chart_tooltip">
                                <div class="tooltip_title flex_js_wrap">
                                    <p class="ellipsis">${params.name}</p>
                                </div>
                                <div class="tooltip_content flex_js_wrap"><span>${params.marker} ${params.value}</span> <span>${params.data.rate}%</span></div>
                        </div>`
                        return params.data.id ? handleHml : html
                    }
                },
                xAxis: {
                    type: 'category',
                    data: barData.map(item => { return item.name})
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: barData,
                        type: 'bar'
                    }
                ]
            };

            option && this.myChartBar.setOption(option);
            // this.myChartBar.off('click');
            this.myChartBar.getDom().addEventListener('click', that.handleChartClick);

        },

        // 相关切换
        handleClickRelatedTab(tab){

            this.formInfoList = []
            this.relatedTabActive = tab
            if(this.relatedTabActive == 'payment'){ // 回款
                this.getOrderRepaymentList()
            }else if(this.relatedTabActive == 'cost'){// 成本
                this.getProjectManageCostList()
            }else if(this.relatedTabActive == 'invoice'){// 开票
                this.getOrderInvoiceSummary()
            }else if(this.relatedTabActive == 'add_out_record'){ //出库记录
                this.getStockOutList()
            }else if(this.relatedTabActive == 'add_in_record'){ //入库记录
                this.getStockInList()
            }else{
                let field_form = this.relatedTabActive == 'business' ? 'projects' : this.relatedTabActive == 'order' ? 'orders' : this.relatedTabActive == 'work_order' ?'workorders' : this.relatedTabActive
                this.businessTableList = []
                this.orderTableList = []
                this.workOrderTableList = []
                this._getFromFields(field_form)
            }


        },
        // 筛选回车
        handleKeyUpEnter(){
            if(this.$refs.search_input_ref){
                this.$refs.search_input_ref.blur()
            }
        },
        // 相关筛选
        handleClickBusinessRelatedSearch(){
            this.pagination.pageNum = 1;
            if(this.activeName == 'project_board'){
                this.getProjectLogList()
                this.getProjectManageFinancialBoard()
            }else if(this.activeName == 'business_related'){
                if(this.relatedTabActive == 'business'){
                    this.getBusinessTableList()
                }else if(this.relatedTabActive == 'order'){
                    this.getRelatedOrder()
                }else if(this.relatedTabActive == 'work_order'){
                    this.getRelatedWorkOrder()
                }
            }else if(this.activeName == 'approval_related'){
                this.getProjectManageApprovalList()
            }else if(this.activeName == 'project_members'){
                this.getProjectManageMemberList()
            }else if(this.activeName == 'project_file'){
                this.getProjectFileList()
            }else if(this.activeName == 'financial_related'){
                if(this.relatedTabActive == 'payment'){
                    this.getOrderRepaymentList()
                }else if(this.relatedTabActive == 'cost'){

                }else if(this.relatedTabActive == 'invoice'){
                    this.getOrderInvoiceSummary()
                }
            }else if(this.activeName == 'inventory_related'){
                this.getProjectManageStockCostDetail()
                if(this.relatedTabActive == 'add_out_record'){ //出库记录
                    this.getStockOutList()
                }else if(this.relatedTabActive == 'add_in_record'){ //入库记录
                    this.getStockInList()
                }
            }
        },
        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.handleClickBusinessRelatedSearch();
        },
        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize;
            this.handleClickBusinessRelatedSearch();
        },
        //获取自定义字段列表
        _getFromFields(field_form) {
            this.loading = true
            getFormFields({
                field_form: field_form,
                filter_field_type: ''
            }).then(res => {
                if (res.code === 200) {
                    if(field_form == 'projects' || field_form == 'workorders'){
                        this.formInfoList = res.data
                    }else if(field_form == 'orders'){
                        res.data.forEach(item => {
                            if (item._child && item._child.length) {
                                item._child.forEach(item => {
                                    if (item.field_key !== 'order_goods') {
                                        this.formInfoList.push(item)
                                    }
                                })
                            }
                        })
                    }

                    this.handleClickBusinessRelatedSearch()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },

        //获取关联的商机列表
        getBusinessTableList() {
            this.loading = true
            projectList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.business_related_keyword,
                project_manage_id:this.projectId
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.businessTableList = data
                    this.pagination.total = total
                    tableDataFieldShow(this.formInfoList, this.businessTableList)
                }
                this.loading = false
            })
        },
        // 获取关联的订单
        getRelatedOrder(){
            this.loading = true
            orderList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.business_related_keyword,
                project_manage_id:this.projectId
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.orderTableList = data
                    this.pagination.total = total
                    tableDataFieldShow(this.formInfoList, this.orderTableList)
                }
                this.loading = false;
            })
        },
        // 获取关联的工单
        getRelatedWorkOrder(){
            this.loading = true
            workOrderList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.business_related_keyword,
                project_manage_id:this.projectId
            }).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.workOrderTableList = data;
                    this.pagination.total = total;
                    tableDataFieldShow(this.formInfoList, this.workOrderTableList);
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false;
            });
        },
        // 获取回款列表
        getOrderRepaymentList(){
            if(this.projectDetail.order_list.length == 0){return false}
            this.loading = true
            orderRepaymentList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.payment_related_keyword,
                order_no_arr:this.projectDetail.order_list.map(item => item.order_num),
                status:[2]
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.paymentTableList = data
                    this.pagination.total = total
                }
                this.loading = false;
            })
        },
        // 获取开票列表
        getOrderInvoiceSummary(){
            if(this.projectDetail.order_list.length == 0){return false}
            this.loading = true
            orderInvoiceSummary({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.payment_related_keyword,
                order_no_arr:this.projectDetail.order_list.map(item => item.order_num),
                status:[2]
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.invoiceTableList = data
                    this.pagination.total = total
                }
                this.loading = false;
            })
        },
        // 获取关联库存的 - 数据看板
        getProjectManageStockCostDetail(){
            let postData = {
                project_manage_id:this.projectId,
                order_ids:this.projectDetail.order_list.map(item => item.order_id)
            }
            ProjectManageStockCostDetail(postData).then(res => {
                if (res.code === 200) {
                    this.outInventoryData = res.data.out //数据看板-出库
                    this.inInventoryData = res.data.in //数据看板-入库
                }
            })
        },
        // 获取出库记录
        getStockOutList(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.stock_record_related_keyword,
                project_manage_id:this.projectId,
                order_ids:this.projectDetail.order_list.map(item => item.order_id)
            }
            stockOutList(postData).then(res => {
                if (res.code === 200) {
                    const {list, total} = res.data
                    this.outRecordTableList = list
                    this.pagination.total = total
                }
                this.loading = false;
            })
        },
        // 获取入库记录
        getStockInList(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.stock_record_related_keyword,
                project_manage_id:this.projectId,
                order_ids:this.projectDetail.order_list.map(item => item.order_id)
            }
            stockInList(postData).then(res => {
                if (res.code === 200) {
                    const {list, total} = res.data
                    this.inRecordTableList = list
                    this.pagination.total = total
                }
                this.loading = false;
            })
        },
        // 获取关联的审批
        getProjectManageApprovalList(){

            this.loading = true
            let postData = {
                project_manage_id:this.projectId,
                page: this.pagination.pageNum,
                size: this.pagination.pageSize,
                keyword: this.project_members_keyword
            }
            ProjectManageApprovalList(postData).then((res) => {
                if (res.code == 200) {
                    let {data,total} = res.data
                    this.approvalTableList = data
                    this.pagination.total = total
                }
                this.loading = false
            })
        },

        // 获取项目成员
        getProjectManageMemberList(){
            this.loading = true
            let postData = {
               project_manage_id:this.projectId,
               page: this.pagination.pageNum,
               size: this.pagination.pageSize,
               keyword: this.project_members_keyword
            }
            ProjectManageMemberList(postData).then((res) => {
                if (res.code == 200) {
                    let {data,total} = res.data
                    data.forEach(item => {
                        item.permission_range_text = this.getPermissionDescriptions(item.permission_range)
                    })
                    this.membersTableList = data
                    this.pagination.total = total
                }
                this.loading = false
            })
        },
        // 成员权限
        getPermissionDescriptions(permissionsArray) {
            // 权限映射表
            const permissionMap = {
                business_related_detail: '项目详情-业务相关-查看权限',
                business_manage: '项目详情-业务相关-管理权限（可新增或关联商机、订单、工单）',
                financial_related_detail: '项目详情-财务相关-查看权限',
                financial_payment: '项目详情-财务相关-可查看项目回款/开票数据',
                financial_profit: '项目详情-财务相关-可查看项目实际利润/项目成本数据',
                financial_cost: '项目详情-财务相关-可新增/编辑/删除项目成本',
                inventory_related_detail: '项目详情-库存相关-查看权限',
                inventory_total_cost: '项目详情-库存相关-可查看产品成本总价',
                member_related_detail: '项目详情-项目成员-查看权限',
                member_operate: '项目详情-项目成员-添加成员/操作权限',
                project_file_detail: '项目详情-项目资料-查看权限',
                project_file_operate: '项目详情-项目资料-上传/操作权限'
            };

            return permissionsArray
                    .filter(perm => perm in permissionMap)
                    .map(perm => permissionMap[perm])
                    .join(', ');
        },
        // 获取项目资料
        getProjectFileList(){
            this.pagination.total = 0
            this.loading = true
            ProjectFileList({ project_manage_id:this.projectId, keyword: this.project_file_keyword }).then((res) => {
                if (res.code == 200) {
                    this.fileTableList = res.data
                }
                this.loading = false
            })
        },
        // 关联的功能操作
        handleClickRelateHandle(type,data){
            this.$refs.relatedHandle.projectId = this.projectId
            this.$refs.relatedHandle.projectDetail = this.projectDetail
            this.$refs.relatedHandle.handleClickRelateHandle(type,data)
        },
        // 关联功能操作完毕后回调
        relatedHandleSuccess(data){
            if(data.type == 'business_disassociation'){
                this.projectDetail.business_number = this.projectDetail.business_number  - 1
            }if(data.type == 'order_disassociation'){
                this.projectDetail.order_number = this.projectDetail.order_number - 1
            }else if(data.type == 'work_order_disassociation'){
                this.projectDetail.work_order_number = this.projectDetail.work_order_number  - 1
            }
            this.getProjectDetail(true)
            this.handleClickBusinessRelatedSearch()
        },

        // 编辑
        handleClickEditProject(){
            this.projectEditVisible = true
        },
        // 更换负责人
        handleClickChangePerson(){
            this.changeThePersonDialogVisible = true
        },
        // 更换负责人回调
        changeThePersonSuccess(){
            this.getProjectDetail()
            if(this.activeName == 'project_members'){
                this.handleClickBusinessRelatedSearch()
            }
        },
        // 完结
        handleClickEnd(){
            const h = this.$createElement;
            this.$msgbox({
                title: '完结提示',
                message: h('div', null, [
                    h('span', null, '项目完结后，将不再同步数据，在选择项目时，该项目将隐藏，无法关联'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                ProjectManageFinish({id:this.projectId}).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '完结成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => { }
                        })
                        this.getProjectDetail()
                    }
                })
            }).catch(() => {

            })
        },
        // 取消完结
        handleClickCancelEnd(){
            const h = this.$createElement;
            this.$msgbox({
                title: '取消完结',
                message: h('div', null, [
                    h('span', null, '确定要取消完结吗？已关联的数据将同步更新'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                ProjectManageFinishCancel({id:this.projectId}).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '取消完结成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => { }
                        })
                        this.getProjectDetail()
                    }
                })
            }).catch(() => {

            })
        },
        // 关闭
        handleClickClose(row){
            const h = this.$createElement;
            this.$msgbox({
                title: '关闭提示',
                message: h('div', null, [
                    h('span', null, '关闭项目后未处理完的事项将不再同步，在选择项目时，该项目将隐藏，无法关联'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                ProjectManageClose({id:this.projectId}).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '关闭成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => { }
                        })
                        this.getProjectDetail()
                    }
                })
            }).catch(() => {

            })
        },
        // 取消关闭
        handleClickCancelClose(){
            const h = this.$createElement;
            this.$msgbox({
                title: '取消关闭',
                message: h('div', null, [
                    h('span', null, '确定要取消关闭吗？已关联的数据将同步更新'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                ProjectManageCloseCancel({id:this.projectId}).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '取消关闭成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => { }
                        })
                        this.getProjectDetail()
                    }
                })
            }).catch(() => {

            })
        },
        // 删除
        handleClickDelete(){
            const h = this.$createElement;
            this.$msgbox({
                title: '删除提示',
                message: h('div', null, [
                    h('span', null, '确定要删除该项目吗？删除后，项目数据将会清空'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: 'prompt_message_custom',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass:  '',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                ProjectManageDel({id:this.projectId}).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => {
                                this.$router.back()
                            }
                        })
                    }
                })
            }).catch(() => {

            })
        },

        // 附件上传
        handleUploadChange(event) {
            const files = event.target.files
            const that = this;
            let file_list = []
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        file_list.push(res)
                        event.target.value = ''
                    }
                    this.setProjectFileAdd(file_list)
                    event.target.value = ''
                }).catch(error => {
                    event.target.value = ''
                })
            })
        },
        // 上传资料
        setProjectFileAdd(file_list){
            ProjectFileAdd({ files:file_list, project_manage_id:this.projectId }).then((res) => {
                if (res.code == 200) {
                    this.$message.success('上传成功')
                    if(this.activeName == 'project_file'){
                        this.getProjectFileList()
                    }
                }
            });
        },
        // 预览
        handleClickPreview(file) {
            let file_type = getFileType(file.file_name)
            if (file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不支持预览，请下载后查看')
                }
            }
        },
        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
        // 删除附件
        handleClickDelFile(row){
            this.$msgbox({
                title: '确定要删除该文件吗？',
                message: '删除后不可恢复，请谨慎操作！',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                ProjectFileDel({ id:row.id }).then((res) => {
                    if (res.code == 200) {
                        this.$message.success('删除成功')
                        this.getProjectFileList()
                    }
                });
            }).catch(() => {

            })
        },
        // 日志映射
        getLogDescriptions(log){
            let data = null
            switch (log.type) {
                case "project_add":
                    data = {
                        title:'新建商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:'',
                        info:{project_id:log.relate_id, name:log?.content?.project_name}
                    }
                    break;  //新增商机
                case "project_relate":
                    data = {
                        title:'关联商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:'',
                        info:{project_id:log.relate_id, name:log?.content?.project_name}
                    }
                    break; //关联商机
                case "project_push":
                    data = {
                        title:'商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:`已推进至“${log.content?.project_stage_name}”阶段`,
                        info:{project_id:log.relate_id, name:log?.content?.project_name}
                    }
                    break; //商机推进
                case "project_add_quotation":
                    data = {
                        title:'商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:`新增报价`,
                        info:{project_id:log.relate_id, name:log?.content?.project_name},
                        derivative_num:log.content?.project_quotation_num,  //衍生编号
                        derivative_handle_type:'view_the_quotation', //衍生操作type
                        derivative:{  //衍生信息
                            project_quotation_id:log.content?.project_quotation_id,
                            title:log.content?.project_quotation_num,
                        }
                    }
                    break; //商机新增报价

                case "order_add":
                    data = {
                        title:'新建订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break; //新增订单
                case "order_relate":
                    data = {
                        title:'关联订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break; //关联订单
                case "order_edit":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-订单编辑`,
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break;//订单编辑
                case "order_stock_edit_out":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-订单编辑-出库`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.out_num,  //衍生编号
                        derivative_handle_type:'out_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            out_num:log.content?.out_num,
                            id:log.content?.out_id,
                        }
                    }
                    break;//订单编辑


                case "order_rent_to_sale":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-租借转销售`,
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break;//售后-租借转销售
                case "order_purchase":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`新增代采，代采编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.purchase_num,  //衍生编号
                        derivative_handle_type:'order_purchase_detail', //衍生操作type
                        derivative:{  //衍生信息
                            purchase_num:log.content?.purchase_num,
                            id:log.content?.purchase_id,
                        }
                    }
                    break;//订单代采
                case "order_invoice":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`新建开票${log.content?.invoice_price}，开票编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.invoice_num,  //衍生编号
                        derivative_handle_type:'invoice_detail', //衍生操作type
                        derivative:{  //衍生信息
                            invoice_no:log.content?.invoice_num,
                        }
                    }
                    break;//订单发起开票
                case "order_repay":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`新建回款${log.content?.repay_price}，回款编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.repay_num,  //衍生编号
                        derivative_handle_type:'payment_detail', //衍生操作type
                        derivative:{  //衍生信息
                            receivable_no:log.content?.repay_num,
                        }
                    }
                    break; //订单发起回款
                case "order_return":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-归还`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                    break;//订单归还
                case "order_stock_out":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`已出库，出库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.out_num,  //衍生编号
                        derivative_handle_type:'out_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            out_num:log.content?.out_num,
                            id:log.content?.out_id,
                        }
                    }
                    break;//订单出库
                case "order_stock_returned_in":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`售后退货已入库，入库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.in_num,  //衍生编号
                        derivative_handle_type:'in_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            in_num:log.content?.in_num,
                            id:log.content?.in_id,
                        }
                    }
                    break;//订单退货入库
                case "order_stock_return_in":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`订单归还已入库，入库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.in_num,  //衍生编号
                        derivative_handle_type:'in_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            in_num:log.content?.in_num,
                            id:log.content?.in_id,
                        }
                    }
                    break;//订单归还入库
                case "order_stock_replace_in":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`订单损坏换新已入库，入库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.in_num,  //衍生编号
                        derivative_handle_type:'in_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            in_num:log.content?.in_num,
                            id:log.content?.in_id,
                        }
                    }
                    break; //订单损坏换新入库
                case "order_stock_replace_out":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`订单损坏换新已出库，出库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.out_num,  //衍生编号
                        derivative_handle_type:'out_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            out_num:log.content?.out_num,
                            id:log.content?.out_id,
                        }
                    }
                    break; //订单损坏换新出库
                case "order_return_goods":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-退货`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        // derivative_num:log.content?.out_num,  //衍生编号
                        // derivative_handle_type:'out_record_detail', //衍生操作type
                        // derivative:{  //衍生信息
                        //     out_num:log.content?.out_num,
                        //     id:log.content?.out_id,
                        // }
                    }
                    break;//订单退货

                case "order_renew":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-续租`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                break; //订单续租
                case "order_replace":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-损坏换新`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                break;  //订单损坏换新
                case "order_refund":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-退款`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                break;  //订单退款
                case "stock_out":
                    data = {
                        title:`普通出库：出库编号`,
                        handle_type:'out_record_detail',
                        relate_num:`${log.relate_num}`,
                        content_text:'',
                        info:{id:log.relate_id}
                    }
                    break; //普通出库
                case "stock_in":
                    data = {
                        title:`普通人库：入库编号`,
                        handle_type:'in_record_detail',
                        relate_num:`${log.relate_num}`,
                        content_text:'',
                        info:{id:log.relate_id}
                    }
                    break; //普通入库

                case "finance_bad_debt":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`坏账金额${log.content?.bad_price}`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:'详情',  //衍生编号
                        derivative_handle_type:'finance_bad_debt_detail', //衍生操作type
                        derivative:{  //衍生信息
                            related_num:log.relate_num,
                        }
                    }
                break;//订单坏账
                case "finance_repay_confirm":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`回款${log.content?.repay_price}已确认，回款编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.repay_num,  //衍生编号
                        derivative_handle_type:'payment_detail', //衍生操作type
                        derivative:{  //衍生信息
                            receivable_no:log.content?.repay_num,
                        }
                    }
                break; //财务回款确认
                case "finance_repay_void":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`回款${log.content?.void_price}已作废，回款编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.void_num,  //衍生编号
                        derivative_handle_type:'payment_detail', //衍生操作type
                        derivative:{  //衍生信息
                            receivable_no:log.content?.void_num,
                        }
                    }
                break; //回款作废
                case "finance_order_invoice":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`开票${log.content?.invoice_price}已确认，开票编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.invoice_num,  //衍生编号
                        derivative_handle_type:'invoice_detail', //衍生操作type
                        derivative:{  //衍生信息
                            invoice_no:log.content?.invoice_num,
                        }
                    }
                break; //财务确认开票
                case "finance_order_refund":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`退款${log.content?.refund_price}已确认，应付编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.payable_no,  //衍生编号
                        derivative_handle_type:'payable_detail', //衍生操作type
                        derivative:{  //衍生信息
                            id:log.content?.payable_no,
                        }

                    }
                break;  //财务确认订单退款
               //'finance_purchase_refund':'采购退款待定',
               //'finance_purchase_payment':'采购付款待定',

                case "workorder_add":
                    data = {
                        title:'新建工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //新建工单
                case "workorder_relate":
                    data = {
                        title:'关联工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //关联工单

                case "workorder_feedback_start":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`${log.content.processing_name}已开始实施`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                break; //工单开始
                case "workorder_depart":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`${log.content.processing_name}已出发`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                break; //工单实施人出发
                case "workorder_feedback_end":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`${log.content.processing_name}已实施完成`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                break; //工单实施人结束
                case "workorder_close":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`已关闭`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单关闭
                case "workorder_finish":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`已结单`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单结单
                case "workorder_evaluate":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`已评价`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单评价


                case "approval_relate":
                    data = {
                        title:`${log.user?.name}关联${log.content?.approval_set_name}，审批编号`,
                        handle_type:'approval_detail',
                        relate_num:`ID：${log.relate_id}`,
                        content_text:'',
                        info:{approval_id:log.relate_id}
                    }
                break; //关联审批
                case "approval_add":
                    data = {
                        title:`${log.user?.name}发起${log.content?.approval_set_name}，审批编号`,
                        handle_type:'approval_detail',
                        relate_num:`ID：${log.relate_id}`,
                        content_text:'',
                        info:{approval_id:log.relate_id}
                    }
                break; //新建审批

                default:
                    data = {
                        title:`${log.user?.name}`,
                        handle_type:'',
                        relate_num:`${log.relate_num}`,
                        content_text:'',
                        info:{relate_id:log.relate_id}
                    }
                    break;
            }
            return data
        },
    }
}
</script>

<style lang="scss" scoped >
@import "@/styles/project_management.scss";
</style>
<style lang="scss">
.project_upload_button{
    position: relative;
    .upload_input{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 100;
        opacity: 0;
        cursor: pointer;
        width: 100%;
    }
}
.custom_dropdown_translate{
    transform: translate(-90px,-43px) !important
}
.custom_chart_tooltip {
    background-color: #ffffff;
    padding: 12px;
    border-radius: 2px;
    border: 0;
    box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px  rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
    .tooltip_title {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.45);
        p{
            max-width: 120px;
        }
    }
    .tooltip_content {
        margin-top: 12px;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 1);
        display: flex;
        justify-content: space-between;
        gap: 24px;
        .count {
            font-weight: 500;
        }
        .chart_circle_item {
            display: flex;
            align-items: center;
            .chart_circle {
                display: inline-block;
                vertical-align: middle;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 9px;
            }
        }
    }
}
</style>